import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AssetFilePath: { input: any; output: any; }
  ContentType: { input: string; output: string; }
  DateTime: { input: Date; output: Date; }
  EmailAddress: { input: string; output: string; }
  FormattedText: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  JWT: { input: string; output: string; }
  Latitude: { input: any; output: any; }
  Longitude: { input: any; output: any; }
  PhoneNumber: { input: string; output: string; }
  Slug: { input: string; output: string; }
  URL: { input: string; output: string; }
};

export enum IAccessibility {
  /** Accessible by public transport within the city */
  PublicTransport = 'PUBLIC_TRANSPORT',
  /** Accessible by train or bus */
  TrainBus = 'TRAIN_BUS'
}

export enum IAdditionalActivities {
  Castles = 'CASTLES',
  EducationalTrails = 'EDUCATIONAL_TRAILS',
  LookoutTowers = 'LOOKOUT_TOWERS',
  Picnic = 'PICNIC',
  Playgrounds = 'PLAYGROUNDS',
  Swimming = 'SWIMMING',
  WellnessSauna = 'WELLNESS_SAUNA'
}

export type IArea = {
  __typename: 'Area';
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  regions: Array<IRegion>;
  status: IAreaStatus;
  translations: Array<INameDescriptionTranslationOutput>;
};

export type IAreaCreateInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  regions: Array<IRegion>;
};

export enum IAreaStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type IAreaTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IAreaUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Array<IRegion>>;
};

export type IArticle = IPublishableInterface & {
  __typename: 'Article';
  _id: Scalars['ID']['output'];
  approvedBy?: Maybe<IUserContact>;
  author: IUserContact;
  availableLanguages: Array<ILanguage>;
  content: Scalars['FormattedText']['output'];
  createdAt: Scalars['DateTime']['output'];
  image?: Maybe<IAsset>;
  isFeatured: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  label?: Maybe<IPublishableLabel>;
  perex: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionMessage?: Maybe<Scalars['String']['output']>;
  slug: Scalars['Slug']['output'];
  status: IPublishableStatus;
  title: Scalars['String']['output'];
  translations: Array<IPublishableTranslationOutput>;
  updatedAt: Scalars['DateTime']['output'];
};

export type IArticleCreateInput = {
  content: Scalars['String']['input'];
  imageAsset?: InputMaybe<Scalars['ID']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['ID']['input']>;
  perex: Scalars['String']['input'];
  preview: Scalars['String']['input'];
  slug: Scalars['Slug']['input'];
  title: Scalars['String']['input'];
};

export type IArticleUpdateInput = {
  author?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  imageAsset?: InputMaybe<Scalars['ID']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['ID']['input']>;
  perex?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['Slug']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IAsset = {
  __typename: 'Asset';
  _id: Scalars['ID']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  contentType: Scalars['ContentType']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: IUserContact;
  filePath: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type IAssetCreateInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['ContentType']['input'];
  filePath: Scalars['AssetFilePath']['input'];
  name: Scalars['String']['input'];
};

export type IAssetFilterInput = {
  contentType?: InputMaybe<Array<Scalars['ContentType']['input']>>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type IAssetPage = {
  __typename: 'AssetPage';
  edges: Array<IAsset>;
  total: Scalars['Int']['output'];
};

export type IAssetUploadInfo = {
  __typename: 'AssetUploadInfo';
  filePath: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type ICity = {
  __typename: 'City';
  _id: Scalars['ID']['output'];
  coordinates: ICoordinates;
  longname: Scalars['String']['output'];
  municipality: Scalars['String']['output'];
  name: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type ICityFilterInput = {
  search: Scalars['String']['input'];
};

export type IContentPreview = {
  __typename: 'ContentPreview';
  _id: Scalars['ID']['output'];
  contentType: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ICoordinates = {
  __typename: 'Coordinates';
  lat: Scalars['Latitude']['output'];
  lng: Scalars['Longitude']['output'];
};

export type ICoordinatesInput = {
  lat: Scalars['Latitude']['input'];
  lng: Scalars['Longitude']['input'];
};

export type IDiscountCode = {
  __typename: 'DiscountCode';
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  claimedBy?: Maybe<IUserContact>;
};

export type IDiscountCodeBatch = {
  __typename: 'DiscountCodeBatch';
  batchNumber: Scalars['Int']['output'];
  claimedCodes: Scalars['Int']['output'];
  codes: Array<IDiscountCode>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  totalCodes: Scalars['Int']['output'];
};

export type IDiscountCodeReward = IPartnerReward & {
  __typename: 'DiscountCodeReward';
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  codeBatches: Array<IDiscountCodeBatch>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  image: IAsset;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  partner: IPartner;
  stats?: Maybe<IDiscountCodeStats>;
  translations: Array<INameDescriptionTranslationOutput>;
  type: IPartnerRewardType;
};

export type IDiscountCodeRewardCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  image: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  partner: Scalars['ID']['input'];
};

export type IDiscountCodeRewardUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['ID']['input']>;
};

export type IDiscountCodeStats = {
  __typename: 'DiscountCodeStats';
  claimed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type IDiscountCodesUploadInput = {
  codes: Array<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IEmailConfirmationToken = {
  __typename: 'EmailConfirmationToken';
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  email: Scalars['EmailAddress']['output'];
  roles: Array<IRole>;
  type: IEmailConfirmationType;
};

export enum IEmailConfirmationType {
  Confirmation = 'CONFIRMATION',
  Invite = 'INVITE'
}

export enum IErrorCode {
  ActionNotAllowed = 'ACTION_NOT_ALLOWED',
  BadUserInput = 'BAD_USER_INPUT',
  BadUserInputUserAlreadyExists = 'BAD_USER_INPUT_USER_ALREADY_EXISTS',
  Forbidden = 'FORBIDDEN',
  IncorrectOldPassword = 'INCORRECT_OLD_PASSWORD',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  Unauthorized = 'UNAUTHORIZED',
  UnauthorizedInactive = 'UNAUTHORIZED_INACTIVE',
  UnauthorizedInvalidCredentials = 'UNAUTHORIZED_INVALID_CREDENTIALS',
  UnauthorizedInvalidInviteCode = 'UNAUTHORIZED_INVALID_INVITE_CODE',
  UnauthorizedInviteCodeExpired = 'UNAUTHORIZED_INVITE_CODE_EXPIRED',
  UnauthorizedRecaptchaFailed = 'UNAUTHORIZED_RECAPTCHA_FAILED',
  UnauthorizedRefreshTokenExpired = 'UNAUTHORIZED_REFRESH_TOKEN_EXPIRED',
  UnauthorizedTokenExpired = 'UNAUTHORIZED_TOKEN_EXPIRED',
  UnauthorizedTokenInvalid = 'UNAUTHORIZED_TOKEN_INVALID'
}

export type IFeedPage = {
  __typename: 'FeedPage';
  edges: Array<IPublishedInterface>;
  total: Scalars['Int']['output'];
};

export type IFinishSignUpInput = {
  code: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  language?: InputMaybe<ILanguage>;
  lastname: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum IGastro {
  Bistro = 'BISTRO',
  Confectionery = 'CONFECTIONERY',
  FineCoffee = 'FINE_COFFEE',
  ForestBar = 'FOREST_BAR',
  Restaurant = 'RESTAURANT'
}

export type ILabelTranslationOutput = {
  __typename: 'LabelTranslationOutput';
  label?: Maybe<Scalars['String']['output']>;
  language: ILanguage;
};

export enum ILanguage {
  Cs = 'CS',
  En = 'EN'
}

export type ILocationDiscountReward = IPartnerReward & {
  __typename: 'LocationDiscountReward';
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  /** How many days before the reward can be redeemed again? */
  cooldownDays?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  image: IAsset;
  isActive: Scalars['Boolean']['output'];
  /** Is this reward one time only? */
  isOneTime?: Maybe<Scalars['Boolean']['output']>;
  location: IPartnerLocation;
  name: Scalars['String']['output'];
  partner: IPartner;
  translations: Array<INameDescriptionTranslationOutput>;
  type: IPartnerRewardType;
  /** How many times can this reward be redeemed? */
  usageLimit?: Maybe<Scalars['Int']['output']>;
};

export type ILocationDiscountRewardCreateInput = {
  cooldownDays?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  image: Scalars['ID']['input'];
  isOneTime?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type ILocationDiscountRewardUpdateInput = {
  cooldownDays?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isOneTime?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

export enum IModerationDecision {
  AdminApproved = 'ADMIN_APPROVED',
  AdminRejected = 'ADMIN_REJECTED',
  AutoApproved = 'AUTO_APPROVED',
  AutoRejected = 'AUTO_REJECTED'
}

export type IModerationQueuePage = {
  __typename: 'ModerationQueuePage';
  edges: Array<ITripRating>;
  total: Scalars['Int']['output'];
};

export enum IModerationStatus {
  Approved = 'APPROVED',
  NeedsReview = 'NEEDS_REVIEW',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type IMutation = {
  __typename: 'Mutation';
  approveArticleReview?: Maybe<IPublishableInterface>;
  approveArticleTranslationReview?: Maybe<IPublishableInterface>;
  approveTripRating?: Maybe<ITripRating>;
  approveTripReview?: Maybe<ITrip>;
  approveTripSuggestionContribution?: Maybe<ITripSuggestion>;
  approveTripTranslationReview?: Maybe<ITrip>;
  archiveTripSuggestion?: Maybe<ITripSuggestion>;
  cancelMyTripSuggestionReservation?: Maybe<IPublishedTripSuggestion>;
  changePassword: Scalars['Boolean']['output'];
  createArea: IArea;
  createArticle: IArticle;
  createAsset: IAsset;
  createDiscountCodeReward: IDiscountCodeReward;
  createLocationDiscountReward: ILocationDiscountReward;
  createPartner: IPartner;
  createPartnerLocation: IPartnerLocation;
  createPublishableLabel: IPublishableLabel;
  createReferralCodeReward: IReferralCodeReward;
  createTrip: ITrip;
  createTripAnnouncement: ITripAnnouncement;
  createTripIdea: ITripIdea;
  createTripLabel: ITripLabel;
  createTripSuggestion: ITripSuggestion;
  deleteAccount: Scalars['Boolean']['output'];
  deleteAsset: Scalars['Boolean']['output'];
  deleteAvatar: IUser;
  deleteEmailConfirmation: Scalars['Boolean']['output'];
  deletePublishableLabel: IPublishableLabel;
  deleteTripLabel: ITripLabel;
  finishSignUp: Scalars['Boolean']['output'];
  generateAssetUpload: IAssetUploadInfo;
  generateAvatarUpload: IUploadInfo;
  initCities: Scalars['Boolean']['output'];
  inviteUser: Scalars['Boolean']['output'];
  liftContentBan: Scalars['Boolean']['output'];
  moveArticleToDraft?: Maybe<IPublishableInterface>;
  moveArticleTranslationToDraft?: Maybe<IPublishableInterface>;
  moveTripToDraft?: Maybe<ITrip>;
  moveTripTranslationToDraft?: Maybe<ITrip>;
  processAssets: Scalars['Boolean']['output'];
  publishArea?: Maybe<IArea>;
  publishArticle?: Maybe<IPublishableInterface>;
  publishArticleTranslation?: Maybe<IPublishableInterface>;
  publishTrip?: Maybe<ITrip>;
  publishTripSuggestion?: Maybe<ITripSuggestion>;
  publishTripTranslation?: Maybe<ITrip>;
  rateTrip: Scalars['Boolean']['output'];
  reactivateTripSuggestion?: Maybe<ITripSuggestion>;
  refreshToken: IRefreshTokenResponse;
  rejectArticleReview?: Maybe<IPublishableInterface>;
  rejectArticleTranslationReview?: Maybe<IPublishableInterface>;
  rejectTripRating?: Maybe<ITripRating>;
  rejectTripReview?: Maybe<ITrip>;
  rejectTripSuggestionContribution?: Maybe<ITripSuggestion>;
  rejectTripTranslationReview?: Maybe<ITrip>;
  releaseTripSuggestionReservation?: Maybe<ITripSuggestion>;
  reprocessAsset?: Maybe<IAsset>;
  requestArticleReview?: Maybe<IPublishableInterface>;
  requestArticleTranslationReview?: Maybe<IPublishableInterface>;
  requestPasswordReset: Scalars['Boolean']['output'];
  requestTripReview?: Maybe<ITrip>;
  requestTripTranslationReview?: Maybe<ITrip>;
  resendEmailConfirmation: Scalars['Boolean']['output'];
  reserveTripSuggestion?: Maybe<IPublishedTripSuggestion>;
  resetPassword: Scalars['Boolean']['output'];
  seedArticle: ISeedSlugResult;
  seedBookmarkedArticle: ISeedResult;
  seedBookmarkedTrip: ISeedResult;
  seedCleanup: Scalars['Boolean']['output'];
  seedFindOne?: Maybe<Scalars['JSONObject']['output']>;
  seedFinishedTrip: ISeedResult;
  seedTrip: ISeedSlugResult;
  seedTripSuggestion: ISeedResult;
  seedUser: ISeedUserResult;
  signIn: ITokenResponse;
  signInToAdmin: ITokenResponse;
  signUp: Scalars['Boolean']['output'];
  slugExists: Scalars['Boolean']['output'];
  submitTripSuggestionContribution?: Maybe<IPublishedTripSuggestion>;
  subscribeToNewsletter: Scalars['Boolean']['output'];
  toggleArticleBookmark: Scalars['Boolean']['output'];
  toggleTripBookmark: Scalars['Boolean']['output'];
  toggleTripFinished: Scalars['Boolean']['output'];
  tripSlugExists: Scalars['Boolean']['output'];
  unpublishArea?: Maybe<IArea>;
  unpublishArticle?: Maybe<IPublishableInterface>;
  unpublishArticleTranslation?: Maybe<IPublishableInterface>;
  unpublishTrip?: Maybe<ITrip>;
  unpublishTripTranslation?: Maybe<ITrip>;
  updateArea?: Maybe<IArea>;
  updateAreaTranslation?: Maybe<IArea>;
  updateArticle?: Maybe<IArticle>;
  updateDiscountCodeReward?: Maybe<IDiscountCodeReward>;
  updateLocationDiscountReward?: Maybe<ILocationDiscountReward>;
  updateMyProfile?: Maybe<IUser>;
  updateOnboardingPreferences: Scalars['Boolean']['output'];
  updatePartner?: Maybe<IPartner>;
  updatePartnerLocation?: Maybe<IPartnerLocation>;
  updatePartnerLocationTranslation?: Maybe<IPartnerLocation>;
  updatePartnerRewardTranslation?: Maybe<IPartnerReward>;
  updatePartnerTranslation?: Maybe<IPartner>;
  updatePublishableLabel?: Maybe<IPublishableLabel>;
  updatePublishableLabelTranslation?: Maybe<IPublishableLabel>;
  updatePublishableTranslation?: Maybe<IPublishableInterface>;
  updateReferralCodeReward?: Maybe<IReferralCodeReward>;
  updateTrip?: Maybe<ITrip>;
  updateTripAnnouncement?: Maybe<ITripAnnouncement>;
  updateTripIdea?: Maybe<ITripIdea>;
  updateTripLabel?: Maybe<ITripLabel>;
  updateTripLabelTranslation?: Maybe<ITripLabel>;
  updateTripRatingVisibility?: Maybe<ITripRating>;
  updateTripSuggestion?: Maybe<ITripSuggestion>;
  updateTripTranslation?: Maybe<ITrip>;
  updateUser?: Maybe<IUser>;
  uploadDiscountCodes?: Maybe<Scalars['Boolean']['output']>;
};


export type IMutationApproveArticleReviewArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationApproveArticleTranslationReviewArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
};


export type IMutationApproveTripRatingArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationApproveTripReviewArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationApproveTripSuggestionContributionArgs = {
  contributionId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type IMutationApproveTripTranslationReviewArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
};


export type IMutationArchiveTripSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationCancelMyTripSuggestionReservationArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type IMutationCreateAreaArgs = {
  input: IAreaCreateInput;
};


export type IMutationCreateArticleArgs = {
  input: IArticleCreateInput;
};


export type IMutationCreateAssetArgs = {
  input: IAssetCreateInput;
};


export type IMutationCreateDiscountCodeRewardArgs = {
  input: IDiscountCodeRewardCreateInput;
};


export type IMutationCreateLocationDiscountRewardArgs = {
  input: ILocationDiscountRewardCreateInput;
};


export type IMutationCreatePartnerArgs = {
  input: IPartnerCreateInput;
};


export type IMutationCreatePartnerLocationArgs = {
  input: IPartnerLocationCreateInput;
};


export type IMutationCreatePublishableLabelArgs = {
  input: IPublishableLabelCreateInput;
};


export type IMutationCreateReferralCodeRewardArgs = {
  input: IReferralCodeRewardCreateInput;
};


export type IMutationCreateTripArgs = {
  input: ITripCreateInput;
};


export type IMutationCreateTripAnnouncementArgs = {
  input: ITripAnnouncementCreateInput;
};


export type IMutationCreateTripIdeaArgs = {
  input: ITripIdeaCreateInput;
};


export type IMutationCreateTripLabelArgs = {
  input: ITripLabelCreateInput;
};


export type IMutationCreateTripSuggestionArgs = {
  input: ITripSuggestionCreateInput;
};


export type IMutationDeleteAssetArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationDeleteEmailConfirmationArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationDeletePublishableLabelArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationDeleteTripLabelArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationFinishSignUpArgs = {
  input: IFinishSignUpInput;
};


export type IMutationGenerateAssetUploadArgs = {
  contentType: Scalars['ContentType']['input'];
};


export type IMutationGenerateAvatarUploadArgs = {
  contentType: Scalars['ContentType']['input'];
  fileName: Scalars['String']['input'];
};


export type IMutationInviteUserArgs = {
  input: IUserInviteInput;
};


export type IMutationLiftContentBanArgs = {
  userId: Scalars['ID']['input'];
};


export type IMutationMoveArticleToDraftArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationMoveArticleTranslationToDraftArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
};


export type IMutationMoveTripToDraftArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationMoveTripTranslationToDraftArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
};


export type IMutationPublishAreaArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationPublishArticleArgs = {
  id: Scalars['ID']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IMutationPublishArticleTranslationArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
};


export type IMutationPublishTripArgs = {
  id: Scalars['ID']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IMutationPublishTripSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationPublishTripTranslationArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
};


export type IMutationRateTripArgs = {
  id: Scalars['ID']['input'];
  input: ITripRatingCreateInput;
};


export type IMutationReactivateTripSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationRefreshTokenArgs = {
  refreshToken: Scalars['JWT']['input'];
};


export type IMutationRejectArticleReviewArgs = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type IMutationRejectArticleTranslationReviewArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
  message: Scalars['String']['input'];
};


export type IMutationRejectTripRatingArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type IMutationRejectTripReviewArgs = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type IMutationRejectTripSuggestionContributionArgs = {
  contributionId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type IMutationRejectTripTranslationReviewArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
  message: Scalars['String']['input'];
};


export type IMutationReleaseTripSuggestionReservationArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationReprocessAssetArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationRequestArticleReviewArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationRequestArticleTranslationReviewArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
};


export type IMutationRequestPasswordResetArgs = {
  email: Scalars['EmailAddress']['input'];
};


export type IMutationRequestTripReviewArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationRequestTripTranslationReviewArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
};


export type IMutationResendEmailConfirmationArgs = {
  email: Scalars['EmailAddress']['input'];
};


export type IMutationReserveTripSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type IMutationSeedArticleArgs = {
  input: ISeedArticleInput;
};


export type IMutationSeedBookmarkedArticleArgs = {
  input: ISeedBookmarkedArticleInput;
};


export type IMutationSeedBookmarkedTripArgs = {
  input: ISeedBookmarkedTripInput;
};


export type IMutationSeedFindOneArgs = {
  input: ISeedFindOneInput;
};


export type IMutationSeedFinishedTripArgs = {
  input: ISeedFinishedTripInput;
};


export type IMutationSeedTripArgs = {
  input: ISeedTripInput;
};


export type IMutationSeedTripSuggestionArgs = {
  input: ISeedTripSuggestionInput;
};


export type IMutationSeedUserArgs = {
  input?: InputMaybe<ISeedUserInput>;
};


export type IMutationSignInArgs = {
  input: ISignInInput;
};


export type IMutationSignInToAdminArgs = {
  input: ISignInInput;
};


export type IMutationSignUpArgs = {
  input: ISignUpInput;
};


export type IMutationSlugExistsArgs = {
  currentArticle?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['Slug']['input'];
};


export type IMutationSubmitTripSuggestionContributionArgs = {
  id: Scalars['ID']['input'];
  input: ITripSuggestionContributionInput;
};


export type IMutationSubscribeToNewsletterArgs = {
  email: Scalars['EmailAddress']['input'];
};


export type IMutationToggleArticleBookmarkArgs = {
  article: Scalars['ID']['input'];
};


export type IMutationToggleTripBookmarkArgs = {
  trip: Scalars['ID']['input'];
};


export type IMutationToggleTripFinishedArgs = {
  trip: Scalars['ID']['input'];
};


export type IMutationTripSlugExistsArgs = {
  currentTrip?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['Slug']['input'];
};


export type IMutationUnpublishAreaArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationUnpublishArticleArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationUnpublishArticleTranslationArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
};


export type IMutationUnpublishTripArgs = {
  id: Scalars['ID']['input'];
};


export type IMutationUnpublishTripTranslationArgs = {
  id: Scalars['ID']['input'];
  language: ILanguage;
};


export type IMutationUpdateAreaArgs = {
  id: Scalars['ID']['input'];
  input: IAreaUpdateInput;
};


export type IMutationUpdateAreaTranslationArgs = {
  id: Scalars['ID']['input'];
  input: IAreaTranslationInput;
  language: ILanguage;
};


export type IMutationUpdateArticleArgs = {
  id: Scalars['ID']['input'];
  input: IArticleUpdateInput;
};


export type IMutationUpdateDiscountCodeRewardArgs = {
  id: Scalars['ID']['input'];
  input: IDiscountCodeRewardUpdateInput;
};


export type IMutationUpdateLocationDiscountRewardArgs = {
  id: Scalars['ID']['input'];
  input: ILocationDiscountRewardUpdateInput;
};


export type IMutationUpdateMyProfileArgs = {
  input: IUpdateMyProfileInput;
};


export type IMutationUpdateOnboardingPreferencesArgs = {
  input: IOnboardingPreferencesInput;
};


export type IMutationUpdatePartnerArgs = {
  id: Scalars['ID']['input'];
  input: IPartnerUpdateInput;
};


export type IMutationUpdatePartnerLocationArgs = {
  id: Scalars['ID']['input'];
  input: IPartnerLocationUpdateInput;
};


export type IMutationUpdatePartnerLocationTranslationArgs = {
  id: Scalars['ID']['input'];
  input: IPartnerLocationTranslationInput;
  language: ILanguage;
};


export type IMutationUpdatePartnerRewardTranslationArgs = {
  id: Scalars['ID']['input'];
  input: IPartnerRewardTranslationInput;
  language: ILanguage;
};


export type IMutationUpdatePartnerTranslationArgs = {
  id: Scalars['ID']['input'];
  input: IPartnerTranslationInput;
  language: ILanguage;
};


export type IMutationUpdatePublishableLabelArgs = {
  id: Scalars['ID']['input'];
  input: IPublishableLabelUpdateInput;
};


export type IMutationUpdatePublishableLabelTranslationArgs = {
  id: Scalars['ID']['input'];
  input: IPublishableLabelTranslationInput;
  language: ILanguage;
};


export type IMutationUpdatePublishableTranslationArgs = {
  id: Scalars['ID']['input'];
  input: IPublishableTranslationInput;
  language: ILanguage;
};


export type IMutationUpdateReferralCodeRewardArgs = {
  id: Scalars['ID']['input'];
  input: IReferralCodeRewardUpdateInput;
};


export type IMutationUpdateTripArgs = {
  id: Scalars['ID']['input'];
  input: ITripUpdateInput;
};


export type IMutationUpdateTripAnnouncementArgs = {
  id: Scalars['ID']['input'];
  input: ITripAnnouncementUpdateInput;
};


export type IMutationUpdateTripIdeaArgs = {
  id: Scalars['ID']['input'];
  input: ITripIdeaUpdateInput;
};


export type IMutationUpdateTripLabelArgs = {
  id: Scalars['ID']['input'];
  input: ITripLabelUpdateInput;
};


export type IMutationUpdateTripLabelTranslationArgs = {
  id: Scalars['ID']['input'];
  input: ITripLabelTranslationInput;
  language: ILanguage;
};


export type IMutationUpdateTripRatingVisibilityArgs = {
  id: Scalars['ID']['input'];
  isHidden: Scalars['Boolean']['input'];
};


export type IMutationUpdateTripSuggestionArgs = {
  id: Scalars['ID']['input'];
  input: ITripSuggestionUpdateInput;
};


export type IMutationUpdateTripTranslationArgs = {
  id: Scalars['ID']['input'];
  input: ITripTranslationInput;
  language: ILanguage;
};


export type IMutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: IUserUpdateInput;
};


export type IMutationUploadDiscountCodesArgs = {
  input: IDiscountCodesUploadInput;
  reward: Scalars['ID']['input'];
};

export type INameDescriptionTranslationOutput = {
  __typename: 'NameDescriptionTranslationOutput';
  description?: Maybe<Scalars['String']['output']>;
  language: ILanguage;
  name?: Maybe<Scalars['String']['output']>;
};

export type IOnboardingPreferencesInput = {
  ageRange?: InputMaybe<Scalars['Float']['input']>;
  beverage?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['ID']['input']>;
  onboardingCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  sleeping?: InputMaybe<Scalars['String']['input']>;
  transportation?: InputMaybe<Scalars['String']['input']>;
  travelCompanionPreference?: InputMaybe<Scalars['String']['input']>;
  tripCharacteristics?: InputMaybe<Array<Scalars['String']['input']>>;
  tripDurations?: InputMaybe<Array<ITripDuration>>;
};

export enum IOvernightStay {
  Camping = 'CAMPING',
  Glamping = 'GLAMPING',
  Hostel = 'HOSTEL',
  Hotel = 'HOTEL',
  Pension = 'PENSION',
  Shelters = 'SHELTERS',
  UnderTheSky = 'UNDER_THE_SKY'
}

export type IPaginationInput = {
  /** Must be a positive number */
  pageNumber: Scalars['Int']['input'];
  /** Page size has to be between 1 and 50 */
  pageSize: Scalars['Int']['input'];
};

export type IPartner = {
  __typename: 'Partner';
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  billingAddress?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  identificationNumber?: Maybe<Scalars['String']['output']>;
  image: IAsset;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
  translations: Array<INameDescriptionTranslationOutput>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['URL']['output']>;
};

export type IPartnerCreateInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type IPartnerFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type IPartnerLocation = {
  __typename: 'PartnerLocation';
  _id: Scalars['ID']['output'];
  address: Scalars['String']['output'];
  availableLanguages: Array<ILanguage>;
  coordinates: ICoordinates;
  description?: Maybe<Scalars['String']['output']>;
  images: Array<IAsset>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  partner: IPartner;
  translations: Array<INameDescriptionTranslationOutput>;
};

export type IPartnerLocationCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  coordinates: ICoordinatesInput;
  description?: InputMaybe<Scalars['String']['input']>;
  images: Array<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  partner: Scalars['ID']['input'];
};

export type IPartnerLocationDetail = {
  __typename: 'PartnerLocationDetail';
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  coordinates: ICoordinates;
  description?: Maybe<Scalars['String']['output']>;
  images: Array<IAsset>;
  name: Scalars['String']['output'];
  partner: IPartnerPreview;
  rewards: Array<IPartnerLocationDiscountRewardPreview>;
};

export type IPartnerLocationDiscountRewardPreview = {
  __typename: 'PartnerLocationDiscountRewardPreview';
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  description?: Maybe<Scalars['String']['output']>;
  /** In case of limited rewards, whether the limit was reached */
  hasReachedLimit?: Maybe<Scalars['Boolean']['output']>;
  image: IAsset;
  isAvailable: Scalars['Boolean']['output'];
  location: IPartnerLocationPreview;
  name: Scalars['String']['output'];
  /** In case there is a cooldown, how many days remain to redeem the reward */
  remainingCooldownDays?: Maybe<Scalars['Int']['output']>;
  type: IPartnerRewardType;
  /** In case of one-time rewards, whether the reward was already redeemed */
  wasAlreadyRedeemed?: Maybe<Scalars['Boolean']['output']>;
};

export type IPartnerLocationPage = {
  __typename: 'PartnerLocationPage';
  edges: Array<IPartnerLocation>;
  total: Scalars['Int']['output'];
};

export type IPartnerLocationPreview = {
  __typename: 'PartnerLocationPreview';
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  coordinates: ICoordinates;
  description?: Maybe<Scalars['String']['output']>;
  images: Array<IAsset>;
  name: Scalars['String']['output'];
  partner: IPartnerPreview;
  rewardCount: Scalars['Int']['output'];
  rewardNames: Array<Scalars['String']['output']>;
};

export type IPartnerLocationTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IPartnerLocationUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<ICoordinatesInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['ID']['input']>;
};

export type IPartnerPage = {
  __typename: 'PartnerPage';
  edges: Array<IPartner>;
  total: Scalars['Int']['output'];
};

export type IPartnerPreview = {
  __typename: 'PartnerPreview';
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  website?: Maybe<Scalars['URL']['output']>;
};

export type IPartnerReward = {
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  image: IAsset;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  partner: IPartner;
  translations: Array<INameDescriptionTranslationOutput>;
  type: IPartnerRewardType;
};

export type IPartnerRewardPage = {
  __typename: 'PartnerRewardPage';
  edges: Array<IPartnerReward>;
  total: Scalars['Int']['output'];
};

export type IPartnerRewardTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum IPartnerRewardType {
  DiscountCode = 'DISCOUNT_CODE',
  LocationDiscount = 'LOCATION_DISCOUNT',
  ReferralCode = 'REFERRAL_CODE'
}

export type IPartnerTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IPartnerUpdateInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type IPublishableInterface = {
  _id: Scalars['ID']['output'];
  approvedBy?: Maybe<IUserContact>;
  author: IUserContact;
  availableLanguages: Array<ILanguage>;
  createdAt: Scalars['DateTime']['output'];
  image?: Maybe<IAsset>;
  isPublic: Scalars['Boolean']['output'];
  label?: Maybe<IPublishableLabel>;
  preview: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionMessage?: Maybe<Scalars['String']['output']>;
  status: IPublishableStatus;
  title: Scalars['String']['output'];
  translations: Array<IPublishableTranslationOutput>;
  updatedAt: Scalars['DateTime']['output'];
};

export type IPublishableLabel = {
  __typename: 'PublishableLabel';
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  translations: Array<ILabelTranslationOutput>;
};

export type IPublishableLabelCreateInput = {
  color: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type IPublishableLabelTranslationInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type IPublishableLabelUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export enum IPublishableStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED',
  Review = 'REVIEW'
}

export type IPublishableTranslationInput = {
  content?: InputMaybe<Scalars['FormattedText']['input']>;
  perex?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['Slug']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IPublishableTranslationOutput = {
  __typename: 'PublishableTranslationOutput';
  approvedBy?: Maybe<IUserContact>;
  content?: Maybe<Scalars['FormattedText']['output']>;
  language: ILanguage;
  perex?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  rejectionMessage?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['Slug']['output']>;
  status?: Maybe<ITranslationStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum IPublishableType {
  Article = 'ARTICLE',
  Trip = 'TRIP'
}

export type IPublishablesFilterInput = {
  author?: InputMaybe<Scalars['ID']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<IPublishableStatus>;
  type?: InputMaybe<IPublishableType>;
};

export type IPublishablesPage = {
  __typename: 'PublishablesPage';
  edges: Array<IPublishableInterface>;
  total: Scalars['Int']['output'];
};

export type IPublishedArticle = IPublishedInterface & {
  __typename: 'PublishedArticle';
  _id: Scalars['ID']['output'];
  author: IUserContact;
  availableLanguages: Array<ILanguage>;
  content: Scalars['FormattedText']['output'];
  image: IAsset;
  isBookmarked?: Maybe<Scalars['Boolean']['output']>;
  isFeatured: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  label?: Maybe<IPublishableLabel>;
  perex: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['Slug']['output'];
  status: IPublishableStatus;
  title: Scalars['String']['output'];
};

export type IPublishedArticleFilterInput = {
  author?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type IPublishedArticlePage = {
  __typename: 'PublishedArticlePage';
  edges: Array<IPublishedArticle>;
  total: Scalars['Int']['output'];
};

export type IPublishedInterface = {
  _id: Scalars['ID']['output'];
  author: IUserContact;
  availableLanguages: Array<ILanguage>;
  image: IAsset;
  isPublic: Scalars['Boolean']['output'];
  label?: Maybe<IPublishableLabel>;
  preview: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status: IPublishableStatus;
  title: Scalars['String']['output'];
};

export type IPublishedTrip = {
  __typename: 'PublishedTrip';
  _id: Scalars['ID']['output'];
  area: IArea;
  attributes: ITripAttributes;
  author: IUserContact;
  authors: Array<IUserContact>;
  availableLanguages: Array<ILanguage>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  content: Scalars['FormattedText']['output'];
  coordinates: ICoordinates;
  coverImage: IAsset;
  hasRated: Scalars['Boolean']['output'];
  images: Array<IAsset>;
  isBookmarked: Scalars['Boolean']['output'];
  isFinished: Scalars['Boolean']['output'];
  isRecommended: Scalars['Boolean']['output'];
  label?: Maybe<ITripLabel>;
  myRating?: Maybe<IPublishedTripRating>;
  partnerLocations: Array<IPartnerLocationPreview>;
  perex: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  ratings: IPublishedTripRatingPage;
  routeLink: Scalars['URL']['output'];
  slug: Scalars['Slug']['output'];
  status: ITripStatus;
  title: Scalars['String']['output'];
};


export type IPublishedTripRatingsArgs = {
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};

export type IPublishedTripAnnouncement = IPublishedInterface & {
  __typename: 'PublishedTripAnnouncement';
  _id: Scalars['ID']['output'];
  author: IUserContact;
  availableLanguages: Array<ILanguage>;
  image: IAsset;
  isPublic: Scalars['Boolean']['output'];
  label?: Maybe<IPublishableLabel>;
  preview: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status: IPublishableStatus;
  title: Scalars['String']['output'];
  trip: IPublishedTrip;
};

export type IPublishedTripFilterInput = {
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  attributes?: InputMaybe<ITripAttributesFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type IPublishedTripPage = {
  __typename: 'PublishedTripPage';
  edges: Array<IPublishedTrip>;
  total: Scalars['Int']['output'];
};

export type IPublishedTripPageWithMetadata = {
  __typename: 'PublishedTripPageWithMetadata';
  edges: Array<IPublishedTrip>;
  total: Scalars['Int']['output'];
  totalKm: Scalars['Float']['output'];
};

export type IPublishedTripRating = {
  __typename: 'PublishedTripRating';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  moderationStatus: IModerationStatus;
  score: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  user: IUserContact;
};

export type IPublishedTripRatingPage = {
  __typename: 'PublishedTripRatingPage';
  edges: Array<IPublishedTripRating>;
  total: Scalars['Int']['output'];
};

export type IPublishedTripSuggestion = {
  __typename: 'PublishedTripSuggestion';
  _id: Scalars['ID']['output'];
  area?: Maybe<IArea>;
  author: IUserContact;
  content: Scalars['FormattedText']['output'];
  contributionMode: ITripSuggestionContributionMode;
  coordinates: ICoordinates;
  hasContributed: Scalars['Boolean']['output'];
  images: Array<IAsset>;
  isReserved: Scalars['Boolean']['output'];
  isReservedByMe: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reservationDeadlineDays?: Maybe<Scalars['Int']['output']>;
  reservationExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  routeLink?: Maybe<Scalars['URL']['output']>;
  status: ITripSuggestionStatus;
  title: Scalars['String']['output'];
};

export type IPublishedTripSuggestionFilterInput = {
  area?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type IQuery = {
  __typename: 'Query';
  area?: Maybe<IArea>;
  areaSelectOptions: Array<ISelectOption>;
  areas: Array<IArea>;
  asset: IAsset;
  assets: IAssetPage;
  cities: Array<ICity>;
  contentPreviews: Array<IContentPreview>;
  dashboardBadTripRatings: Array<ITripRating>;
  discountCodeBatches: Array<IDiscountCodeBatch>;
  errorCodes: Array<IErrorCode>;
  featuredArticles: Array<Maybe<IPublishedArticle>>;
  feed: IFeedPage;
  me: IUser;
  moderationQueue: IModerationQueuePage;
  myBookmarkedArticles: IPublishedArticlePage;
  myBookmarkedArticlesCount: Scalars['Int']['output'];
  myBookmarkedTrips: IPublishedTripPage;
  myBookmarkedTripsCount: Scalars['Int']['output'];
  myContributedTripSuggestions: Array<IPublishedTripSuggestion>;
  myFinishedTrips: IPublishedTripPageWithMetadata;
  myFinishedTripsCount: Scalars['Int']['output'];
  myReservedTripSuggestions: Array<IPublishedTripSuggestion>;
  myTotalKm: Scalars['Float']['output'];
  partner?: Maybe<IPartner>;
  partnerLocation?: Maybe<IPartnerLocation>;
  partnerLocationDetail?: Maybe<IPartnerLocationDetail>;
  partnerLocationOptions: Array<ISelectOption>;
  partnerLocations: IPartnerLocationPage;
  partnerReward?: Maybe<IPartnerReward>;
  partnerRewards: IPartnerRewardPage;
  partners: IPartnerPage;
  publishable?: Maybe<IPublishableInterface>;
  publishableLabels: Array<IPublishableLabel>;
  publishables: IPublishablesPage;
  publishedArticle?: Maybe<IPublishedArticle>;
  publishedArticles: IPublishedArticlePage;
  publishedTrip?: Maybe<IPublishedTrip>;
  publishedTripSuggestion?: Maybe<IPublishedTripSuggestion>;
  publishedTripSuggestionLocations: Array<ITripSuggestionLocation>;
  publishedTripSuggestionsResultsCount: Scalars['Int']['output'];
  publishedTrips: IPublishedTripPage;
  publishedTripsResultsCount: Scalars['Int']['output'];
  recaptchaActions: Array<IRecaptchaAction>;
  recommendedTrips: Array<IRecommendedTrip>;
  sendTestEmail: Scalars['Boolean']['output'];
  similarTrips: Array<IRecommendedTrip>;
  sitemap: ISitemapData;
  trip?: Maybe<ITrip>;
  tripCountPerRegion: Array<IRegionCount>;
  tripIdea?: Maybe<ITripIdea>;
  tripIdeaLocations: Array<ITripIdeaLocation>;
  tripIdeas: ITripIdeaPage;
  tripLabels: Array<ITripLabel>;
  tripOptions: Array<ITripOption>;
  tripRating?: Maybe<ITripRating>;
  tripRatings: ITripRatingPage;
  tripSuggestion?: Maybe<ITripSuggestion>;
  tripSuggestionLocations: Array<ITripSuggestionLocation>;
  tripSuggestions: ITripSuggestionPage;
  trips: ITripPage;
  tripsLocations: Array<ITripLocation>;
  user?: Maybe<IUser>;
  userInvites: Array<IEmailConfirmationToken>;
  userModerationStats: IUserModerationStats;
  userSelectOptions: Array<IUserSelectOption>;
  users: IUserPage;
};


export type IQueryAreaArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryAreaSelectOptionsArgs = {
  language?: InputMaybe<ILanguage>;
};


export type IQueryAssetArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryAssetsArgs = {
  filter: IAssetFilterInput;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};


export type IQueryCitiesArgs = {
  filter: ICityFilterInput;
};


export type IQueryContentPreviewsArgs = {
  articleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type IQueryDashboardBadTripRatingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type IQueryDiscountCodeBatchesArgs = {
  reward: Scalars['ID']['input'];
};


export type IQueryFeaturedArticlesArgs = {
  language?: InputMaybe<ILanguage>;
};


export type IQueryFeedArgs = {
  filter: IPublishedArticleFilterInput;
  language?: InputMaybe<ILanguage>;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};


export type IQueryModerationQueueArgs = {
  pagination: IPaginationInput;
  status?: InputMaybe<IModerationStatus>;
};


export type IQueryMyBookmarkedArticlesArgs = {
  language?: InputMaybe<ILanguage>;
  pagination: IPaginationInput;
};


export type IQueryMyBookmarkedTripsArgs = {
  language?: InputMaybe<ILanguage>;
  pagination: IPaginationInput;
};


export type IQueryMyFinishedTripsArgs = {
  language?: InputMaybe<ILanguage>;
  pagination: IPaginationInput;
};


export type IQueryPartnerArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryPartnerLocationArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryPartnerLocationDetailArgs = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<ILanguage>;
};


export type IQueryPartnerLocationOptionsArgs = {
  partner?: InputMaybe<Scalars['ID']['input']>;
};


export type IQueryPartnerLocationsArgs = {
  pagination: IPaginationInput;
  partner: Scalars['ID']['input'];
  sort?: InputMaybe<ISortInput>;
};


export type IQueryPartnerRewardArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryPartnerRewardsArgs = {
  pagination: IPaginationInput;
  partner: Scalars['ID']['input'];
  sort?: InputMaybe<ISortInput>;
};


export type IQueryPartnersArgs = {
  filter: IPartnerFilterInput;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};


export type IQueryPublishableArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryPublishablesArgs = {
  filter: IPublishablesFilterInput;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};


export type IQueryPublishedArticleArgs = {
  language?: InputMaybe<ILanguage>;
  slug: Scalars['Slug']['input'];
};


export type IQueryPublishedArticlesArgs = {
  filter: IPublishedArticleFilterInput;
  language?: InputMaybe<ILanguage>;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};


export type IQueryPublishedTripArgs = {
  language?: InputMaybe<ILanguage>;
  slug: Scalars['Slug']['input'];
};


export type IQueryPublishedTripSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryPublishedTripSuggestionLocationsArgs = {
  filter?: InputMaybe<IPublishedTripSuggestionFilterInput>;
};


export type IQueryPublishedTripSuggestionsResultsCountArgs = {
  filter?: InputMaybe<IPublishedTripSuggestionFilterInput>;
};


export type IQueryPublishedTripsArgs = {
  filter: IPublishedTripFilterInput;
  language?: InputMaybe<ILanguage>;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};


export type IQueryPublishedTripsResultsCountArgs = {
  filter: IPublishedTripFilterInput;
};


export type IQueryRecommendedTripsArgs = {
  language?: InputMaybe<ILanguage>;
  options?: InputMaybe<IRecommendationOptionsInput>;
};


export type IQuerySimilarTripsArgs = {
  language?: InputMaybe<ILanguage>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tripId: Scalars['ID']['input'];
};


export type IQueryTripArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryTripIdeaArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryTripIdeaLocationsArgs = {
  filter: ITripIdeaFilterInput;
};


export type IQueryTripIdeasArgs = {
  filter: ITripIdeaFilterInput;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};


export type IQueryTripRatingArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryTripRatingsArgs = {
  filter: ITripRatingFilterInput;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};


export type IQueryTripSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryTripSuggestionLocationsArgs = {
  filter: ITripSuggestionFilterInput;
};


export type IQueryTripSuggestionsArgs = {
  filter: ITripSuggestionFilterInput;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};


export type IQueryTripsArgs = {
  filter: ITripFilterInput;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};


export type IQueryTripsLocationsArgs = {
  filter: IPublishedTripFilterInput;
  language?: InputMaybe<ILanguage>;
};


export type IQueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type IQueryUserModerationStatsArgs = {
  userId: Scalars['ID']['input'];
};


export type IQueryUserSelectOptionsArgs = {
  filter: IUserSelectOptionsFilterInput;
};


export type IQueryUsersArgs = {
  filter: IUserFilterInput;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
};

export enum IRecaptchaAction {
  FinishSignUp = 'FINISH_SIGN_UP',
  RequestPasswordReset = 'REQUEST_PASSWORD_RESET',
  ResetPassword = 'RESET_PASSWORD',
  SignInAsAdmin = 'SIGN_IN_AS_ADMIN',
  SignInViaEmailAndPassword = 'SIGN_IN_VIA_EMAIL_AND_PASSWORD',
  SignUp = 'SIGN_UP',
  SubscribeToNewsletter = 'SUBSCRIBE_TO_NEWSLETTER',
  SupportMessage = 'SUPPORT_MESSAGE'
}

export type IRecommendationOptionsInput = {
  excludeFinished?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Browser location coordinates. Overrides user city for location-based recommendations. */
  location?: InputMaybe<ICoordinatesInput>;
  maxDistanceKm?: InputMaybe<Scalars['Float']['input']>;
};

/** The reason why a trip was recommended */
export enum IRecommendationReason {
  Curated = 'CURATED',
  Fresh = 'FRESH',
  MatchesPreferences = 'MATCHES_PREFERENCES',
  Nearby = 'NEARBY',
  Popular = 'POPULAR',
  Similar = 'SIMILAR',
  SimilarToFavorites = 'SIMILAR_TO_FAVORITES'
}

export type IRecommendedTrip = {
  __typename: 'RecommendedTrip';
  _id: Scalars['ID']['output'];
  area: IArea;
  availableLanguages: Array<ILanguage>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  coverImage: IAsset;
  distanceKm?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<ITripLabel>;
  preview: Scalars['String']['output'];
  reason: IRecommendationReason;
  slug: Scalars['Slug']['output'];
  status: ITripStatus;
  title: Scalars['String']['output'];
};

export type IReferralCodeReward = IPartnerReward & {
  __typename: 'ReferralCodeReward';
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  image: IAsset;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  partner: IPartner;
  translations: Array<INameDescriptionTranslationOutput>;
  type: IPartnerRewardType;
};

export type IReferralCodeRewardCreateInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  image: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  partner: Scalars['ID']['input'];
};

export type IReferralCodeRewardUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['ID']['input']>;
};

export type IRefreshTokenResponse = {
  __typename: 'RefreshTokenResponse';
  accessToken: Scalars['JWT']['output'];
};

export enum IRegion {
  CentralBohemian = 'CENTRAL_BOHEMIAN',
  HradecKralove = 'HRADEC_KRALOVE',
  KarlovyVary = 'KARLOVY_VARY',
  Liberec = 'LIBEREC',
  MoravianSilesian = 'MORAVIAN_SILESIAN',
  Olomouc = 'OLOMOUC',
  Pardubice = 'PARDUBICE',
  Pilsen = 'PILSEN',
  PragueCapital = 'PRAGUE_CAPITAL',
  SouthBohemian = 'SOUTH_BOHEMIAN',
  SouthMoravian = 'SOUTH_MORAVIAN',
  Usti = 'USTI',
  Vysocina = 'VYSOCINA',
  Zlin = 'ZLIN'
}

export type IRegionCount = {
  __typename: 'RegionCount';
  count: Scalars['Int']['output'];
  region: IRegion;
};

export enum IRole {
  Admin = 'ADMIN',
  BlogEditor = 'BLOG_EDITOR',
  ChiefEditor = 'CHIEF_EDITOR',
  PartnerEditor = 'PARTNER_EDITOR',
  TripEditor = 'TRIP_EDITOR',
  UnpublishedViewer = 'UNPUBLISHED_VIEWER',
  User = 'USER',
  UserManager = 'USER_MANAGER'
}

export enum IRouteType {
  AToB = 'A_TO_B',
  Circuit = 'CIRCUIT'
}

export type ISeedArticleInput = {
  authorId: Scalars['ID']['input'];
  enPerex?: InputMaybe<Scalars['String']['input']>;
  enSlug?: InputMaybe<Scalars['String']['input']>;
  enTitle?: InputMaybe<Scalars['String']['input']>;
  perex?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<IPublishableStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  withEnTranslation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ISeedBookmarkedArticleInput = {
  articleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ISeedBookmarkedTripInput = {
  tripId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ISeedFindOneInput = {
  collection: Scalars['String']['input'];
  filter: Scalars['JSONObject']['input'];
};

export type ISeedFinishedTripInput = {
  tripId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ISeedResult = {
  __typename: 'SeedResult';
  id: Scalars['ID']['output'];
};

export type ISeedSlugResult = {
  __typename: 'SeedSlugResult';
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ISeedTripInput = {
  authorId: Scalars['ID']['input'];
  contributorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  enPerex?: InputMaybe<Scalars['String']['input']>;
  enSlug?: InputMaybe<Scalars['String']['input']>;
  enTitle?: InputMaybe<Scalars['String']['input']>;
  perex?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ITripStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  withEnTranslation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ISeedTripSuggestionInput = {
  authorId: Scalars['ID']['input'];
  contributionMode?: InputMaybe<ITripSuggestionContributionMode>;
  coordinates?: InputMaybe<Array<Scalars['Float']['input']>>;
  reservationDeadlineDays?: InputMaybe<Scalars['Int']['input']>;
  reservedById?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ITripSuggestionStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ISeedUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  hasActivePass?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<ILanguage>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  onboardingCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<IRole>>;
};

export type ISeedUserResult = {
  __typename: 'SeedUserResult';
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type ISelectOption = {
  __typename: 'SelectOption';
  label: Scalars['String']['output'];
  subLabel?: Maybe<Scalars['String']['output']>;
  value: Scalars['ID']['output'];
};

export enum ISex {
  F = 'F',
  M = 'M'
}

export type ISignInInput = {
  email: Scalars['EmailAddress']['input'];
  password: Scalars['String']['input'];
};

export type ISignUpInput = {
  email: Scalars['EmailAddress']['input'];
};

export type ISitemapData = {
  __typename: 'SitemapData';
  articles: Array<ISitemapEntry>;
  trips: Array<ISitemapEntry>;
};

export type ISitemapEntry = {
  __typename: 'SitemapEntry';
  imageUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['Slug']['output'];
};

export enum ISortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ISortInput = {
  direction: ISortDirection;
  field: Scalars['String']['input'];
};

export enum ISuitability {
  Children = 'CHILDREN',
  Dogs = 'DOGS',
  Stroller = 'STROLLER'
}

export enum ITerrain {
  Asphalt = 'ASPHALT',
  FieldPath = 'FIELD_PATH',
  Mixed = 'MIXED',
  Stone = 'STONE'
}

export type ITokenResponse = {
  __typename: 'TokenResponse';
  accessToken: Scalars['JWT']['output'];
  refreshToken: Scalars['JWT']['output'];
};

export enum ITranslationStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED',
  Review = 'REVIEW'
}

export type ITrip = {
  __typename: 'Trip';
  _id: Scalars['ID']['output'];
  approvedBy?: Maybe<IUserContact>;
  area: IArea;
  attributes: ITripAttributes;
  author: IUserContact;
  authors: Array<IUserContact>;
  availableLanguages: Array<ILanguage>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  content: Scalars['FormattedText']['output'];
  contributors: Array<IUserContact>;
  coordinates: ICoordinates;
  createdAt: Scalars['DateTime']['output'];
  images: Array<IAsset>;
  info?: Maybe<ITripInfo>;
  isPublic: Scalars['Boolean']['output'];
  isRecommended: Scalars['Boolean']['output'];
  label?: Maybe<ITripLabel>;
  mappedAt?: Maybe<Scalars['DateTime']['output']>;
  partnerLocations: Array<IPartnerLocation>;
  perex: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionMessage?: Maybe<Scalars['String']['output']>;
  routeLink: Scalars['URL']['output'];
  slug: Scalars['Slug']['output'];
  status: ITripStatus;
  title: Scalars['String']['output'];
  translations: Array<ITripTranslationOutput>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ITripAnnouncement = IPublishableInterface & {
  __typename: 'TripAnnouncement';
  _id: Scalars['ID']['output'];
  approvedBy?: Maybe<IUserContact>;
  author: IUserContact;
  availableLanguages: Array<ILanguage>;
  createdAt: Scalars['DateTime']['output'];
  image?: Maybe<IAsset>;
  isPublic: Scalars['Boolean']['output'];
  label?: Maybe<IPublishableLabel>;
  preview: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionMessage?: Maybe<Scalars['String']['output']>;
  status: IPublishableStatus;
  title: Scalars['String']['output'];
  translations: Array<IPublishableTranslationOutput>;
  trip: ITrip;
  updatedAt: Scalars['DateTime']['output'];
};

export type ITripAnnouncementCreateInput = {
  imageAsset?: InputMaybe<Scalars['ID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['ID']['input']>;
  preview: Scalars['String']['input'];
  title: Scalars['String']['input'];
  trip: Scalars['ID']['input'];
};

export type ITripAnnouncementUpdateInput = {
  author?: InputMaybe<Scalars['ID']['input']>;
  imageAsset?: InputMaybe<Scalars['ID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['ID']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trip?: InputMaybe<Scalars['ID']['input']>;
};

export type ITripAttributeInput = {
  accessibility?: InputMaybe<Array<InputMaybe<IAccessibility>>>;
  additionalActivities?: InputMaybe<Array<IAdditionalActivities>>;
  duration?: InputMaybe<ITripDuration>;
  gastro?: InputMaybe<Array<IGastro>>;
  lengthKm?: InputMaybe<Scalars['Float']['input']>;
  overnightStay?: InputMaybe<Array<IOvernightStay>>;
  routeType?: InputMaybe<IRouteType>;
  suitability?: InputMaybe<Array<ISuitability>>;
  terrain?: InputMaybe<Array<InputMaybe<ITerrain>>>;
};

export type ITripAttributes = {
  __typename: 'TripAttributes';
  _id: Scalars['ID']['output'];
  accessibility: Array<Maybe<IAccessibility>>;
  additionalActivities?: Maybe<Array<IAdditionalActivities>>;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<ITripDuration>;
  gastro?: Maybe<Array<IGastro>>;
  lengthKm?: Maybe<Scalars['Float']['output']>;
  overnightStay?: Maybe<Array<IOvernightStay>>;
  routeType?: Maybe<IRouteType>;
  suitability?: Maybe<Array<ISuitability>>;
  terrain: Array<Maybe<ITerrain>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ITripAttributesFilterInput = {
  accessibility?: InputMaybe<Array<InputMaybe<IAccessibility>>>;
  additionalActivities?: InputMaybe<Array<IAdditionalActivities>>;
  duration?: InputMaybe<Array<InputMaybe<ITripDuration>>>;
  gastro?: InputMaybe<Array<IGastro>>;
  lengthKmMax?: InputMaybe<Scalars['Int']['input']>;
  lengthKmMin?: InputMaybe<Scalars['Int']['input']>;
  overnightStay?: InputMaybe<Array<IOvernightStay>>;
  routeType?: InputMaybe<Array<InputMaybe<IRouteType>>>;
  suitability?: InputMaybe<Array<ISuitability>>;
  terrain?: InputMaybe<Array<InputMaybe<ITerrain>>>;
};

export type ITripCreateInput = {
  area: Scalars['String']['input'];
  attributes: ITripAttributeInput;
  content: Scalars['String']['input'];
  contributors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  coordinates: ICoordinatesInput;
  images: Array<InputMaybe<Scalars['ID']['input']>>;
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['ID']['input']>;
  mappedAt?: InputMaybe<Scalars['DateTime']['input']>;
  partnerLocations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  perex: Scalars['String']['input'];
  preview: Scalars['String']['input'];
  routeLink: Scalars['URL']['input'];
  slug: Scalars['Slug']['input'];
  title: Scalars['String']['input'];
};

export enum ITripDuration {
  HalfDay = 'HALF_DAY',
  ShortWalk = 'SHORT_WALK',
  Weekend = 'WEEKEND',
  WholeDay = 'WHOLE_DAY'
}

export type ITripFilterInput = {
  area?: InputMaybe<Scalars['ID']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['ID']['input']>;
  mappedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  mappedTo?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ITripStatus>;
};

export type ITripIdea = {
  __typename: 'TripIdea';
  _id: Scalars['ID']['output'];
  area?: Maybe<IArea>;
  author: IUserContact;
  content: Scalars['FormattedText']['output'];
  coordinates: ICoordinates;
  createdAt: Scalars['DateTime']['output'];
  routeLink?: Maybe<Scalars['URL']['output']>;
  status: ITripIdeaStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ITripIdeaCreateInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  coordinates: ICoordinatesInput;
  routeLink?: InputMaybe<Scalars['URL']['input']>;
  title: Scalars['String']['input'];
};

export type ITripIdeaFilterInput = {
  area?: InputMaybe<Scalars['ID']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ITripIdeaStatus>;
};

export type ITripIdeaLocation = {
  __typename: 'TripIdeaLocation';
  _id: Scalars['ID']['output'];
  coordinates: ICoordinates;
  status: ITripIdeaStatus;
  title: Scalars['String']['output'];
};

export type ITripIdeaPage = {
  __typename: 'TripIdeaPage';
  edges: Array<ITripIdea>;
  total: Scalars['Int']['output'];
};

export enum ITripIdeaStatus {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  New = 'NEW'
}

export type ITripIdeaUpdateInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<ICoordinatesInput>;
  routeLink?: InputMaybe<Scalars['URL']['input']>;
  status?: InputMaybe<ITripIdeaStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ITripInfo = {
  __typename: 'TripInfo';
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ITripInfoType;
};

export type ITripInfoInput = {
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: ITripInfoType;
};

export type ITripInfoTranslationInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ITripInfoTranslationOutput = {
  __typename: 'TripInfoTranslationOutput';
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum ITripInfoType {
  Info = 'INFO',
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE',
  Warning = 'WARNING'
}

export type ITripLabel = {
  __typename: 'TripLabel';
  _id: Scalars['ID']['output'];
  availableLanguages: Array<ILanguage>;
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  translations: Array<ILabelTranslationOutput>;
};

export type ITripLabelCreateInput = {
  color: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type ITripLabelTranslationInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ITripLabelUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ITripLocation = {
  __typename: 'TripLocation';
  _id: Scalars['ID']['output'];
  attributes: ITripAttributes;
  availableLanguages: Array<ILanguage>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  coordinates: ICoordinates;
  coverImage: IAsset;
  isBookmarked: Scalars['Boolean']['output'];
  label?: Maybe<ITripLabel>;
  preview: Scalars['String']['output'];
  slug: Scalars['Slug']['output'];
  status: ITripStatus;
  title: Scalars['String']['output'];
};

export type ITripOption = {
  __typename: 'TripOption';
  _id: Scalars['ID']['output'];
  coverImage: IAsset;
  preview: Scalars['String']['output'];
  status: ITripStatus;
  title: Scalars['String']['output'];
};

export type ITripPage = {
  __typename: 'TripPage';
  edges: Array<ITrip>;
  total: Scalars['Int']['output'];
};

export type ITripRating = {
  __typename: 'TripRating';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  moderatedAt?: Maybe<Scalars['DateTime']['output']>;
  moderatedBy?: Maybe<IUserContact>;
  moderationDecision?: Maybe<IModerationDecision>;
  moderationReason?: Maybe<Scalars['String']['output']>;
  moderationStatus: IModerationStatus;
  score: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  trip: IPublishedTrip;
  user: IUserContact;
};

export type ITripRatingCreateInput = {
  score: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  trip: Scalars['ID']['input'];
};

export type ITripRatingFilterInput = {
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  trip?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type ITripRatingPage = {
  __typename: 'TripRatingPage';
  edges: Array<ITripRating>;
  total: Scalars['Int']['output'];
};

export enum ITripStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED',
  Review = 'REVIEW'
}

export type ITripSuggestion = {
  __typename: 'TripSuggestion';
  _id: Scalars['ID']['output'];
  area?: Maybe<IArea>;
  author: IUserContact;
  content: Scalars['FormattedText']['output'];
  contribution?: Maybe<ITripSuggestionContribution>;
  contributionMode: ITripSuggestionContributionMode;
  contributions: Array<ITripSuggestionContribution>;
  convertedTripId?: Maybe<Scalars['ID']['output']>;
  coordinates: ICoordinates;
  createdAt: Scalars['DateTime']['output'];
  images: Array<IAsset>;
  isReserved: Scalars['Boolean']['output'];
  isReservedByMe: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reservationDeadlineDays?: Maybe<Scalars['Int']['output']>;
  reservationExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  reservedAt?: Maybe<Scalars['DateTime']['output']>;
  reservedBy?: Maybe<IUserContact>;
  routeLink?: Maybe<Scalars['URL']['output']>;
  status: ITripSuggestionStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ITripSuggestionContribution = {
  __typename: 'TripSuggestionContribution';
  _id: Scalars['ID']['output'];
  author?: Maybe<IUserContact>;
  content: Scalars['FormattedText']['output'];
  images: Array<IAsset>;
  rejectionMessage?: Maybe<Scalars['String']['output']>;
  routeLink?: Maybe<Scalars['URL']['output']>;
  submittedAt: Scalars['DateTime']['output'];
};

export type ITripSuggestionContributionInput = {
  content: Scalars['String']['input'];
  images?: Array<Scalars['ID']['input']>;
  routeLink?: InputMaybe<Scalars['URL']['input']>;
};

export enum ITripSuggestionContributionMode {
  Multiple = 'MULTIPLE',
  Single = 'SINGLE'
}

export type ITripSuggestionCreateInput = {
  area?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  contributionMode?: ITripSuggestionContributionMode;
  coordinates: ICoordinatesInput;
  images?: Array<Scalars['ID']['input']>;
  reservationDeadlineDays?: InputMaybe<Scalars['Int']['input']>;
  routeLink?: InputMaybe<Scalars['URL']['input']>;
  title: Scalars['String']['input'];
};

export type ITripSuggestionFilterInput = {
  area?: InputMaybe<Scalars['ID']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  reservedBy?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ITripSuggestionStatus>;
};

export type ITripSuggestionLocation = {
  __typename: 'TripSuggestionLocation';
  _id: Scalars['ID']['output'];
  coordinates: ICoordinates;
  isReserved: Scalars['Boolean']['output'];
  status: ITripSuggestionStatus;
  title: Scalars['String']['output'];
};

export type ITripSuggestionPage = {
  __typename: 'TripSuggestionPage';
  edges: Array<ITripSuggestion>;
  total: Scalars['Int']['output'];
};

export enum ITripSuggestionStatus {
  Archived = 'ARCHIVED',
  ContributionSubmitted = 'CONTRIBUTION_SUBMITTED',
  Converted = 'CONVERTED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Reserved = 'RESERVED'
}

export type ITripSuggestionUpdateInput = {
  area?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contributionMode?: InputMaybe<ITripSuggestionContributionMode>;
  coordinates?: InputMaybe<ICoordinatesInput>;
  images?: InputMaybe<Array<Scalars['ID']['input']>>;
  reservationDeadlineDays?: InputMaybe<Scalars['Int']['input']>;
  routeLink?: InputMaybe<Scalars['URL']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ITripTranslationInput = {
  content?: InputMaybe<Scalars['FormattedText']['input']>;
  info?: InputMaybe<ITripInfoTranslationInput>;
  perex?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['Slug']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ITripTranslationOutput = {
  __typename: 'TripTranslationOutput';
  approvedBy?: Maybe<IUserContact>;
  content?: Maybe<Scalars['FormattedText']['output']>;
  info?: Maybe<ITripInfoTranslationOutput>;
  language: ILanguage;
  perex?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  rejectionMessage?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['Slug']['output']>;
  status?: Maybe<ITranslationStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ITripUpdateInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<ITripAttributeInput>;
  author?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contributors?: InputMaybe<Array<Scalars['ID']['input']>>;
  coordinates?: InputMaybe<ICoordinatesInput>;
  images?: InputMaybe<Array<Scalars['ID']['input']>>;
  info?: InputMaybe<ITripInfoInput>;
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['ID']['input']>;
  mappedAt?: InputMaybe<Scalars['DateTime']['input']>;
  partnerLocations?: InputMaybe<Array<Scalars['ID']['input']>>;
  perex?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  routeLink?: InputMaybe<Scalars['URL']['input']>;
  slug?: InputMaybe<Scalars['Slug']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IUpdateMyProfileInput = {
  ageRange?: InputMaybe<Scalars['Float']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<ILanguage>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
};

export type IUploadInfo = {
  __typename: 'UploadInfo';
  filePath: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type IUser = {
  __typename: 'User';
  _id: Scalars['ID']['output'];
  ageRange?: Maybe<Scalars['Float']['output']>;
  avatar?: Maybe<Scalars['URL']['output']>;
  city?: Maybe<ICity>;
  contentStrikeCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['EmailAddress']['output'];
  firstname: Scalars['String']['output'];
  fullname: Scalars['String']['output'];
  hasActivePass: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isContentBanned: Scalars['Boolean']['output'];
  language: ILanguage;
  lastname: Scalars['String']['output'];
  onboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
  preferences?: Maybe<IUserPreferences>;
  roles: Array<IRole>;
  sex?: Maybe<ISex>;
};

export type IUserContact = {
  __typename: 'UserContact';
  _id: Scalars['ID']['output'];
  avatar?: Maybe<Scalars['URL']['output']>;
  email: Scalars['EmailAddress']['output'];
  firstname: Scalars['String']['output'];
  fullname: Scalars['String']['output'];
  initials: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  shortname: Scalars['String']['output'];
};

export type IUserFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<IRole>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type IUserInviteInput = {
  email: Scalars['EmailAddress']['input'];
  roles: Array<IRole>;
};

export type IUserModerationStats = {
  __typename: 'UserModerationStats';
  isContentBanned: Scalars['Boolean']['output'];
  rejectedCount: Scalars['Int']['output'];
  strikeCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type IUserPage = {
  __typename: 'UserPage';
  edges: Array<IUser>;
  total: Scalars['Int']['output'];
};

export type IUserPreferences = {
  __typename: 'UserPreferences';
  beverage?: Maybe<Scalars['String']['output']>;
  referralSource?: Maybe<Scalars['String']['output']>;
  sleeping?: Maybe<Scalars['String']['output']>;
  transportation?: Maybe<Scalars['String']['output']>;
  travelCompanionPreference?: Maybe<Scalars['String']['output']>;
  tripCharacteristics?: Maybe<Array<Scalars['String']['output']>>;
  tripDurations?: Maybe<Array<ITripDuration>>;
};

export type IUserSelectOption = {
  __typename: 'UserSelectOption';
  _id: Scalars['ID']['output'];
  email: Scalars['EmailAddress']['output'];
  fullname: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type IUserSelectOptionsFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<IRole>>;
  /** Only returns results if length is 3 and more characters */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type IUserUpdateInput = {
  firstname?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<IRole>>>;
};

export type IGenerateAssetUploadMutationVariables = Exact<{
  contentType: Scalars['ContentType']['input'];
}>;


export type IGenerateAssetUploadMutation = { __typename: 'Mutation', generateAssetUpload: { __typename: 'AssetUploadInfo', filePath: string, url: string } };

export type ICreateAssetMutationVariables = Exact<{
  input: IAssetCreateInput;
}>;


export type ICreateAssetMutation = { __typename: 'Mutation', createAsset: { __typename: 'Asset', _id: string, url: string, name: string, alt?: string } };

export type ISignInMutationVariables = Exact<{
  input: ISignInInput;
}>;


export type ISignInMutation = { __typename: 'Mutation', signIn: { __typename: 'TokenResponse', accessToken: string, refreshToken: string } };

export type ISignUpMutationVariables = Exact<{
  input: ISignUpInput;
}>;


export type ISignUpMutation = { __typename: 'Mutation', signUp: boolean };

export type IFinishSignUpMutationVariables = Exact<{
  input: IFinishSignUpInput;
}>;


export type IFinishSignUpMutation = { __typename: 'Mutation', finishSignUp: boolean };

export type IRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['JWT']['input'];
}>;


export type IRefreshTokenMutation = { __typename: 'Mutation', refreshToken: { __typename: 'RefreshTokenResponse', accessToken: string } };

export type IRequestPasswordResetMutationVariables = Exact<{
  email: Scalars['EmailAddress']['input'];
}>;


export type IRequestPasswordResetMutation = { __typename: 'Mutation', requestPasswordReset: boolean };

export type IResetPasswordMutationVariables = Exact<{
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type IResetPasswordMutation = { __typename: 'Mutation', resetPassword: boolean };

export type IToggleArticleBookmarkMutationVariables = Exact<{
  article: Scalars['ID']['input'];
}>;


export type IToggleArticleBookmarkMutation = { __typename: 'Mutation', toggleArticleBookmark: boolean };

export type IPublishableLabelFragment = { __typename: 'PublishableLabel', _id: string, label: string, color: string };

export type IArticlePreviewItemFragment = { __typename: 'PublishedArticle', _id: string, slug: string, title: string, preview: string, isBookmarked?: boolean, status: IPublishableStatus, label?: { __typename: 'PublishableLabel', _id: string, label: string, color: string }, image: { __typename: 'Asset', _id: string, url: string, alt?: string } };

export type IArticlesQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  filter: IPublishedArticleFilterInput;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
}>;


export type IArticlesQuery = { __typename: 'Query', articles: { __typename: 'PublishedArticlePage', total: number, edges: Array<{ __typename: 'PublishedArticle', _id: string, slug: string, title: string, preview: string, isBookmarked?: boolean, status: IPublishableStatus, label?: { __typename: 'PublishableLabel', _id: string, label: string, color: string }, image: { __typename: 'Asset', _id: string, url: string, alt?: string } }> } };

export type IBookmarkedArticlesQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  pagination: IPaginationInput;
}>;


export type IBookmarkedArticlesQuery = { __typename: 'Query', myBookmarkedArticles: { __typename: 'PublishedArticlePage', total: number, edges: Array<{ __typename: 'PublishedArticle', _id: string, slug: string, title: string, preview: string, isBookmarked?: boolean, status: IPublishableStatus, label?: { __typename: 'PublishableLabel', _id: string, label: string, color: string }, image: { __typename: 'Asset', _id: string, url: string, alt?: string } }> } };

export type ITripAnnouncementItemFragment = { __typename: 'PublishedTripAnnouncement', _id: string, title: string, preview: string, status: IPublishableStatus, label?: { __typename: 'PublishableLabel', _id: string, label: string, color: string }, image: { __typename: 'Asset', _id: string, url: string, alt?: string }, trip: { __typename: 'PublishedTrip', _id: string, slug: string } };

export type IFeedQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  filter: IPublishedArticleFilterInput;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
}>;


export type IFeedQuery = { __typename: 'Query', feed: { __typename: 'FeedPage', total: number, edges: Array<{ __typename: 'PublishedArticle', _id: string, slug: string, title: string, preview: string, isBookmarked?: boolean, status: IPublishableStatus, label?: { __typename: 'PublishableLabel', _id: string, label: string, color: string }, image: { __typename: 'Asset', _id: string, url: string, alt?: string } } | { __typename: 'PublishedTripAnnouncement', _id: string, title: string, preview: string, status: IPublishableStatus, label?: { __typename: 'PublishableLabel', _id: string, label: string, color: string }, image: { __typename: 'Asset', _id: string, url: string, alt?: string }, trip: { __typename: 'PublishedTrip', _id: string, slug: string } }> } };

export type IArticleDetailQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  slug: Scalars['Slug']['input'];
  skipFeatured: Scalars['Boolean']['input'];
}>;


export type IArticleDetailQuery = { __typename: 'Query', featuredArticles?: Array<{ __typename: 'PublishedArticle', _id: string, slug: string, title: string, preview: string, isBookmarked?: boolean, status: IPublishableStatus, label?: { __typename: 'PublishableLabel', _id: string, label: string, color: string }, image: { __typename: 'Asset', _id: string, url: string, alt?: string } }>, article?: { __typename: 'PublishedArticle', _id: string, slug: string, title: string, preview: string, perex: string, content: any, publishedAt?: Date, isBookmarked?: boolean, status: IPublishableStatus, label?: { __typename: 'PublishableLabel', _id: string, label: string, color: string }, image: { __typename: 'Asset', _id: string, url: string, alt?: string }, author: { __typename: 'UserContact', _id: string, shortname: string } } };

export type ISubscribeToNewsletterMutationVariables = Exact<{
  email: Scalars['EmailAddress']['input'];
}>;


export type ISubscribeToNewsletterMutation = { __typename: 'Mutation', subscribeToNewsletter: boolean };

export type IContentPreviewsQueryVariables = Exact<{
  tripIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  articleIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type IContentPreviewsQuery = { __typename: 'Query', contentPreviews: Array<{ __typename: 'ContentPreview', _id: string, contentType: string, slug: string, title: string, imageUrl?: string, preview?: string }> };

export type ICitiesQueryVariables = Exact<{
  filter: ICityFilterInput;
}>;


export type ICitiesQuery = { __typename: 'Query', cities: Array<{ __typename: 'City', _id: string, name: string, region: string }> };

export type ILocationRewardFragment = { __typename: 'PartnerLocationDiscountRewardPreview', _id: string, name: string, description?: string, isAvailable: boolean, hasReachedLimit?: boolean, remainingCooldownDays?: number, wasAlreadyRedeemed?: boolean, image: { __typename: 'Asset', _id: string, url: string, alt?: string }, location: { __typename: 'PartnerLocationPreview', _id: string, name: string, coordinates: { __typename: 'Coordinates', lat: any, lng: any } } };

export type IPartnerLocationPreviewItemFragment = { __typename: 'PartnerLocationPreview', _id: string, name: string, description?: string, rewardCount: number, rewardNames: Array<string>, partner: { __typename: 'PartnerPreview', _id: string, name: string }, images: Array<{ __typename: 'Asset', _id: string, url: string, alt?: string }> };

export type IPartnerLocationDetailFragment = { __typename: 'PartnerLocationDetail', _id: string, name: string, description?: string, partner: { __typename: 'PartnerPreview', _id: string, name: string }, images: Array<{ __typename: 'Asset', _id: string, url: string, alt?: string }>, rewards: Array<{ __typename: 'PartnerLocationDiscountRewardPreview', _id: string, name: string, description?: string, isAvailable: boolean, hasReachedLimit?: boolean, remainingCooldownDays?: number, wasAlreadyRedeemed?: boolean, image: { __typename: 'Asset', _id: string, url: string, alt?: string }, location: { __typename: 'PartnerLocationPreview', _id: string, name: string, coordinates: { __typename: 'Coordinates', lat: any, lng: any } } }> };

export type IPartnerLocationDetailQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  id: Scalars['ID']['input'];
}>;


export type IPartnerLocationDetailQuery = { __typename: 'Query', partnerLocationDetail?: { __typename: 'PartnerLocationDetail', _id: string, name: string, description?: string, partner: { __typename: 'PartnerPreview', _id: string, name: string }, images: Array<{ __typename: 'Asset', _id: string, url: string, alt?: string }>, rewards: Array<{ __typename: 'PartnerLocationDiscountRewardPreview', _id: string, name: string, description?: string, isAvailable: boolean, hasReachedLimit?: boolean, remainingCooldownDays?: number, wasAlreadyRedeemed?: boolean, image: { __typename: 'Asset', _id: string, url: string, alt?: string }, location: { __typename: 'PartnerLocationPreview', _id: string, name: string, coordinates: { __typename: 'Coordinates', lat: any, lng: any } } }> } };

export type IAreasQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
}>;


export type IAreasQuery = { __typename: 'Query', areas: Array<{ __typename: 'SelectOption', value: string, label: string }> };

export type IReserveTripSuggestionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IReserveTripSuggestionMutation = { __typename: 'Mutation', reserveTripSuggestion?: { __typename: 'PublishedTripSuggestion', _id: string, status: ITripSuggestionStatus, reservationExpiresAt?: Date, isReserved: boolean, isReservedByMe: boolean } };

export type ICancelMyTripSuggestionReservationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ICancelMyTripSuggestionReservationMutation = { __typename: 'Mutation', cancelMyTripSuggestionReservation?: { __typename: 'PublishedTripSuggestion', _id: string, status: ITripSuggestionStatus, isReserved: boolean, isReservedByMe: boolean } };

export type ISubmitTripSuggestionContributionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ITripSuggestionContributionInput;
}>;


export type ISubmitTripSuggestionContributionMutation = { __typename: 'Mutation', submitTripSuggestionContribution?: { __typename: 'PublishedTripSuggestion', _id: string, status: ITripSuggestionStatus, hasContributed: boolean } };

export type IPublishedTripSuggestionDetailFragment = { __typename: 'PublishedTripSuggestion', _id: string, status: ITripSuggestionStatus, title: string, routeLink?: string, content: any, contributionMode: ITripSuggestionContributionMode, reservationDeadlineDays?: number, reservationExpiresAt?: Date, isReserved: boolean, isReservedByMe: boolean, hasContributed: boolean, publishedAt?: Date, coordinates: { __typename: 'Coordinates', lat: any, lng: any }, images: Array<{ __typename: 'Asset', _id: string, url: string, name: string, alt?: string }>, area?: { __typename: 'Area', _id: string, name: string }, author: { __typename: 'UserContact', _id: string, fullname: string } };

export type IPublishedTripSuggestionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IPublishedTripSuggestionQuery = { __typename: 'Query', publishedTripSuggestion?: { __typename: 'PublishedTripSuggestion', _id: string, status: ITripSuggestionStatus, title: string, routeLink?: string, content: any, contributionMode: ITripSuggestionContributionMode, reservationDeadlineDays?: number, reservationExpiresAt?: Date, isReserved: boolean, isReservedByMe: boolean, hasContributed: boolean, publishedAt?: Date, coordinates: { __typename: 'Coordinates', lat: any, lng: any }, images: Array<{ __typename: 'Asset', _id: string, url: string, name: string, alt?: string }>, area?: { __typename: 'Area', _id: string, name: string }, author: { __typename: 'UserContact', _id: string, fullname: string } } };

export type IPublishedTripSuggestionLocationsQueryVariables = Exact<{
  filter?: InputMaybe<IPublishedTripSuggestionFilterInput>;
}>;


export type IPublishedTripSuggestionLocationsQuery = { __typename: 'Query', publishedTripSuggestionLocations: Array<{ __typename: 'TripSuggestionLocation', _id: string, title: string, status: ITripSuggestionStatus, isReserved: boolean, coordinates: { __typename: 'Coordinates', lat: any, lng: any } }> };

export type IFilteredTripSuggestionsCountQueryVariables = Exact<{
  filter?: InputMaybe<IPublishedTripSuggestionFilterInput>;
}>;


export type IFilteredTripSuggestionsCountQuery = { __typename: 'Query', count: number };

export type IMyReservedTripSuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type IMyReservedTripSuggestionsQuery = { __typename: 'Query', myReservedTripSuggestions: Array<{ __typename: 'PublishedTripSuggestion', _id: string, status: ITripSuggestionStatus, title: string, routeLink?: string, content: any, contributionMode: ITripSuggestionContributionMode, reservationDeadlineDays?: number, reservationExpiresAt?: Date, isReserved: boolean, isReservedByMe: boolean, hasContributed: boolean, publishedAt?: Date, coordinates: { __typename: 'Coordinates', lat: any, lng: any }, images: Array<{ __typename: 'Asset', _id: string, url: string, name: string, alt?: string }>, area?: { __typename: 'Area', _id: string, name: string }, author: { __typename: 'UserContact', _id: string, fullname: string } }> };

export type IMyContributedTripSuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type IMyContributedTripSuggestionsQuery = { __typename: 'Query', myContributedTripSuggestions: Array<{ __typename: 'PublishedTripSuggestion', _id: string, status: ITripSuggestionStatus, title: string, routeLink?: string, content: any, contributionMode: ITripSuggestionContributionMode, reservationDeadlineDays?: number, reservationExpiresAt?: Date, isReserved: boolean, isReservedByMe: boolean, hasContributed: boolean, publishedAt?: Date, coordinates: { __typename: 'Coordinates', lat: any, lng: any }, images: Array<{ __typename: 'Asset', _id: string, url: string, name: string, alt?: string }>, area?: { __typename: 'Area', _id: string, name: string }, author: { __typename: 'UserContact', _id: string, fullname: string } }> };

export type IRateTripMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ITripRatingCreateInput;
}>;


export type IRateTripMutation = { __typename: 'Mutation', rateTrip: boolean };

export type IToggleTripBookmarkMutationVariables = Exact<{
  trip: Scalars['ID']['input'];
}>;


export type IToggleTripBookmarkMutation = { __typename: 'Mutation', toggleTripBookmark: boolean };

export type IToggleTripFinishedMutationVariables = Exact<{
  trip: Scalars['ID']['input'];
}>;


export type IToggleTripFinishedMutation = { __typename: 'Mutation', toggleTripFinished: boolean };

export type IImageFragment = { __typename: 'Asset', _id: string, url: string, alt?: string };

export type ITripLabelFragment = { __typename: 'TripLabel', _id: string, label: string, color: string };

export type ITripPreviewItemFragment = { __typename: 'PublishedTrip', _id: string, slug: string, title: string, averageRating?: number, isBookmarked: boolean, status: ITripStatus, coverImage: { __typename: 'Asset', _id: string, url: string, alt?: string }, area: { __typename: 'Area', _id: string, name: string }, attributes: { __typename: 'TripAttributes', accessibility: Array<IAccessibility>, gastro?: Array<IGastro>, suitability?: Array<ISuitability>, additionalActivities?: Array<IAdditionalActivities>, overnightStay?: Array<IOvernightStay>, lengthKm?: number, routeType?: IRouteType, terrain: Array<ITerrain>, duration?: ITripDuration }, label?: { __typename: 'TripLabel', _id: string, label: string, color: string } };

export type ITripRatingFragment = { __typename: 'PublishedTripRating', _id: string, score: number, text: string, moderationStatus: IModerationStatus, createdAt: Date, user: { __typename: 'UserContact', _id: string, shortname: string, initials: string } };

export type ITripDetailFragment = { __typename: 'PublishedTrip', _id: string, slug: string, status: ITripStatus, title: string, routeLink: string, preview: string, perex: string, content: any, isBookmarked: boolean, isFinished: boolean, hasRated: boolean, averageRating?: number, publishedAt?: Date, label?: { __typename: 'TripLabel', _id: string, label: string }, images: Array<{ __typename: 'Asset', _id: string, url: string, alt?: string }>, coordinates: { __typename: 'Coordinates', lat: any, lng: any }, area: { __typename: 'Area', _id: string, name: string }, attributes: { __typename: 'TripAttributes', accessibility: Array<IAccessibility>, gastro?: Array<IGastro>, suitability?: Array<ISuitability>, additionalActivities?: Array<IAdditionalActivities>, overnightStay?: Array<IOvernightStay>, lengthKm?: number, routeType?: IRouteType, terrain: Array<ITerrain>, duration?: ITripDuration }, myRating?: { __typename: 'PublishedTripRating', _id: string, score: number, text: string, moderationStatus: IModerationStatus, createdAt: Date, user: { __typename: 'UserContact', _id: string, shortname: string, initials: string } }, ratings: { __typename: 'PublishedTripRatingPage', total: number, edges: Array<{ __typename: 'PublishedTripRating', _id: string, score: number, text: string, moderationStatus: IModerationStatus, createdAt: Date, user: { __typename: 'UserContact', _id: string, shortname: string, initials: string } }> }, author: { __typename: 'UserContact', _id: string, shortname: string }, authors: Array<{ __typename: 'UserContact', _id: string, fullname: string }>, partnerLocations: Array<{ __typename: 'PartnerLocationPreview', _id: string, name: string, description?: string, rewardCount: number, rewardNames: Array<string>, partner: { __typename: 'PartnerPreview', _id: string, name: string }, images: Array<{ __typename: 'Asset', _id: string, url: string, alt?: string }> }> };

export type ITripLocationFragment = { __typename: 'TripLocation', _id: string, slug: string, status: ITripStatus, isBookmarked: boolean, title: string, preview: string, averageRating?: number, coverImage: { __typename: 'Asset', _id: string, url: string, alt?: string }, label?: { __typename: 'TripLabel', _id: string, label: string, color: string }, coordinates: { __typename: 'Coordinates', lat: any, lng: any }, attributes: { __typename: 'TripAttributes', lengthKm?: number, gastro?: Array<IGastro>, suitability?: Array<ISuitability>, additionalActivities?: Array<IAdditionalActivities>, overnightStay?: Array<IOvernightStay> } };

export type IRecommendedTripFragment = { __typename: 'RecommendedTrip', _id: string, slug: string, title: string, preview: string, averageRating?: number, distanceKm?: number, reason: IRecommendationReason, status: ITripStatus, coverImage: { __typename: 'Asset', _id: string, url: string, alt?: string }, area: { __typename: 'Area', _id: string, name: string }, label?: { __typename: 'TripLabel', _id: string, label: string, color: string } };

export type IRecommendedTripsQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  options?: InputMaybe<IRecommendationOptionsInput>;
}>;


export type IRecommendedTripsQuery = { __typename: 'Query', recommendedTrips: Array<{ __typename: 'RecommendedTrip', _id: string, slug: string, title: string, preview: string, averageRating?: number, distanceKm?: number, reason: IRecommendationReason, status: ITripStatus, coverImage: { __typename: 'Asset', _id: string, url: string, alt?: string }, area: { __typename: 'Area', _id: string, name: string }, label?: { __typename: 'TripLabel', _id: string, label: string, color: string } }> };

export type ITripsQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  filter: IPublishedTripFilterInput;
  pagination: IPaginationInput;
  sort?: InputMaybe<ISortInput>;
}>;


export type ITripsQuery = { __typename: 'Query', trips: { __typename: 'PublishedTripPage', total: number, edges: Array<{ __typename: 'PublishedTrip', _id: string, slug: string, title: string, averageRating?: number, isBookmarked: boolean, status: ITripStatus, coverImage: { __typename: 'Asset', _id: string, url: string, alt?: string }, area: { __typename: 'Area', _id: string, name: string }, attributes: { __typename: 'TripAttributes', accessibility: Array<IAccessibility>, gastro?: Array<IGastro>, suitability?: Array<ISuitability>, additionalActivities?: Array<IAdditionalActivities>, overnightStay?: Array<IOvernightStay>, lengthKm?: number, routeType?: IRouteType, terrain: Array<ITerrain>, duration?: ITripDuration }, label?: { __typename: 'TripLabel', _id: string, label: string, color: string } }> } };

export type IBookmarkedTripsQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  pagination: IPaginationInput;
}>;


export type IBookmarkedTripsQuery = { __typename: 'Query', myBookmarkedTrips: { __typename: 'PublishedTripPage', total: number, edges: Array<{ __typename: 'PublishedTrip', _id: string, slug: string, title: string, averageRating?: number, isBookmarked: boolean, status: ITripStatus, coverImage: { __typename: 'Asset', _id: string, url: string, alt?: string }, area: { __typename: 'Area', _id: string, name: string }, attributes: { __typename: 'TripAttributes', accessibility: Array<IAccessibility>, gastro?: Array<IGastro>, suitability?: Array<ISuitability>, additionalActivities?: Array<IAdditionalActivities>, overnightStay?: Array<IOvernightStay>, lengthKm?: number, routeType?: IRouteType, terrain: Array<ITerrain>, duration?: ITripDuration }, label?: { __typename: 'TripLabel', _id: string, label: string, color: string } }> } };

export type IFinishedTripsQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  pagination: IPaginationInput;
}>;


export type IFinishedTripsQuery = { __typename: 'Query', myFinishedTrips: { __typename: 'PublishedTripPageWithMetadata', total: number, totalKm: number, edges: Array<{ __typename: 'PublishedTrip', _id: string, slug: string, title: string, averageRating?: number, isBookmarked: boolean, status: ITripStatus, coverImage: { __typename: 'Asset', _id: string, url: string, alt?: string }, area: { __typename: 'Area', _id: string, name: string }, attributes: { __typename: 'TripAttributes', accessibility: Array<IAccessibility>, gastro?: Array<IGastro>, suitability?: Array<ISuitability>, additionalActivities?: Array<IAdditionalActivities>, overnightStay?: Array<IOvernightStay>, lengthKm?: number, routeType?: IRouteType, terrain: Array<ITerrain>, duration?: ITripDuration }, label?: { __typename: 'TripLabel', _id: string, label: string, color: string } }> } };

export type IFilteredTripsCountQueryVariables = Exact<{
  filter: IPublishedTripFilterInput;
}>;


export type IFilteredTripsCountQuery = { __typename: 'Query', count: number };

export type ITripPreviewQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  slug: Scalars['Slug']['input'];
}>;


export type ITripPreviewQuery = { __typename: 'Query', trip?: { __typename: 'PublishedTrip', _id: string, slug: string, title: string, averageRating?: number, isBookmarked: boolean, status: ITripStatus, coverImage: { __typename: 'Asset', _id: string, url: string, alt?: string }, area: { __typename: 'Area', _id: string, name: string }, attributes: { __typename: 'TripAttributes', accessibility: Array<IAccessibility>, gastro?: Array<IGastro>, suitability?: Array<ISuitability>, additionalActivities?: Array<IAdditionalActivities>, overnightStay?: Array<IOvernightStay>, lengthKm?: number, routeType?: IRouteType, terrain: Array<ITerrain>, duration?: ITripDuration }, label?: { __typename: 'TripLabel', _id: string, label: string, color: string } } };

export type ITripDetailQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  slug: Scalars['Slug']['input'];
}>;


export type ITripDetailQuery = { __typename: 'Query', trip?: { __typename: 'PublishedTrip', _id: string, slug: string, status: ITripStatus, title: string, routeLink: string, preview: string, perex: string, content: any, isBookmarked: boolean, isFinished: boolean, hasRated: boolean, averageRating?: number, publishedAt?: Date, label?: { __typename: 'TripLabel', _id: string, label: string }, images: Array<{ __typename: 'Asset', _id: string, url: string, alt?: string }>, coordinates: { __typename: 'Coordinates', lat: any, lng: any }, area: { __typename: 'Area', _id: string, name: string }, attributes: { __typename: 'TripAttributes', accessibility: Array<IAccessibility>, gastro?: Array<IGastro>, suitability?: Array<ISuitability>, additionalActivities?: Array<IAdditionalActivities>, overnightStay?: Array<IOvernightStay>, lengthKm?: number, routeType?: IRouteType, terrain: Array<ITerrain>, duration?: ITripDuration }, myRating?: { __typename: 'PublishedTripRating', _id: string, score: number, text: string, moderationStatus: IModerationStatus, createdAt: Date, user: { __typename: 'UserContact', _id: string, shortname: string, initials: string } }, ratings: { __typename: 'PublishedTripRatingPage', total: number, edges: Array<{ __typename: 'PublishedTripRating', _id: string, score: number, text: string, moderationStatus: IModerationStatus, createdAt: Date, user: { __typename: 'UserContact', _id: string, shortname: string, initials: string } }> }, author: { __typename: 'UserContact', _id: string, shortname: string }, authors: Array<{ __typename: 'UserContact', _id: string, fullname: string }>, partnerLocations: Array<{ __typename: 'PartnerLocationPreview', _id: string, name: string, description?: string, rewardCount: number, rewardNames: Array<string>, partner: { __typename: 'PartnerPreview', _id: string, name: string }, images: Array<{ __typename: 'Asset', _id: string, url: string, alt?: string }> }> } };

export type ISimilarTripsQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  tripId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ISimilarTripsQuery = { __typename: 'Query', similarTrips: Array<{ __typename: 'RecommendedTrip', _id: string, slug: string, title: string, preview: string, averageRating?: number, distanceKm?: number, reason: IRecommendationReason, status: ITripStatus, coverImage: { __typename: 'Asset', _id: string, url: string, alt?: string }, area: { __typename: 'Area', _id: string, name: string }, label?: { __typename: 'TripLabel', _id: string, label: string, color: string } }> };

export type ITripsLocationsQueryVariables = Exact<{
  language?: InputMaybe<ILanguage>;
  filter: IPublishedTripFilterInput;
}>;


export type ITripsLocationsQuery = { __typename: 'Query', tripsLocations: Array<{ __typename: 'TripLocation', _id: string, slug: string, status: ITripStatus, isBookmarked: boolean, title: string, preview: string, averageRating?: number, coverImage: { __typename: 'Asset', _id: string, url: string, alt?: string }, label?: { __typename: 'TripLabel', _id: string, label: string, color: string }, coordinates: { __typename: 'Coordinates', lat: any, lng: any }, attributes: { __typename: 'TripAttributes', lengthKm?: number, gastro?: Array<IGastro>, suitability?: Array<ISuitability>, additionalActivities?: Array<IAdditionalActivities>, overnightStay?: Array<IOvernightStay> } }> };

export type IChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type IChangePasswordMutation = { __typename: 'Mutation', changePassword: boolean };

export type IUpdateMyProfileMutationVariables = Exact<{
  input: IUpdateMyProfileInput;
}>;


export type IUpdateMyProfileMutation = { __typename: 'Mutation', updateMyProfile?: { __typename: 'User', _id: string } };

export type IUpdateOnboardingPreferencesMutationVariables = Exact<{
  input: IOnboardingPreferencesInput;
}>;


export type IUpdateOnboardingPreferencesMutation = { __typename: 'Mutation', updateOnboardingPreferences: boolean };

export type IDeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type IDeleteAccountMutation = { __typename: 'Mutation', deleteAccount: boolean };

export type IMeFragment = { __typename: 'User', _id: string, fullname: string, firstname: string, lastname: string, email: string, roles: Array<IRole>, sex?: ISex, ageRange?: number, onboardingCompleted?: boolean, hasActivePass: boolean, language: ILanguage, city?: { __typename: 'City', _id: string, name: string } };

export type IMeQueryVariables = Exact<{ [key: string]: never; }>;


export type IMeQuery = { __typename: 'Query', me: { __typename: 'User', _id: string, fullname: string, firstname: string, lastname: string, email: string, roles: Array<IRole>, sex?: ISex, ageRange?: number, onboardingCompleted?: boolean, hasActivePass: boolean, language: ILanguage, city?: { __typename: 'City', _id: string, name: string } } };

export type IProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type IProfileQuery = { __typename: 'Query', myBookmarkedTripsCount: number, myBookmarkedArticlesCount: number, myFinishedTripsCount: number, myTotalKm: number };

export const PublishableLabelFragmentDoc = gql`
    fragment PublishableLabel on PublishableLabel {
  _id
  label
  color
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on Asset {
  _id
  url
  alt
}
    `;
export const ArticlePreviewItemFragmentDoc = gql`
    fragment ArticlePreviewItem on PublishedArticle {
  _id
  slug
  title
  preview
  label {
    ...PublishableLabel
  }
  isBookmarked
  image {
    ...Image
  }
  status
}
    ${PublishableLabelFragmentDoc}
${ImageFragmentDoc}`;
export const TripAnnouncementItemFragmentDoc = gql`
    fragment TripAnnouncementItem on PublishedTripAnnouncement {
  _id
  title
  preview
  label {
    ...PublishableLabel
  }
  image {
    ...Image
  }
  trip {
    _id
    slug
  }
  status
}
    ${PublishableLabelFragmentDoc}
${ImageFragmentDoc}`;
export const LocationRewardFragmentDoc = gql`
    fragment LocationReward on PartnerLocationDiscountRewardPreview {
  _id
  image {
    ...Image
  }
  name
  description
  isAvailable
  hasReachedLimit
  remainingCooldownDays
  wasAlreadyRedeemed
  location {
    _id
    name
    coordinates {
      lat
      lng
    }
  }
}
    ${ImageFragmentDoc}`;
export const PartnerLocationDetailFragmentDoc = gql`
    fragment PartnerLocationDetail on PartnerLocationDetail {
  _id
  name
  description
  partner {
    _id
    name
  }
  images {
    ...Image
  }
  rewards {
    ...LocationReward
  }
}
    ${ImageFragmentDoc}
${LocationRewardFragmentDoc}`;
export const PublishedTripSuggestionDetailFragmentDoc = gql`
    fragment PublishedTripSuggestionDetail on PublishedTripSuggestion {
  _id
  status
  title
  routeLink
  coordinates {
    lat
    lng
  }
  content
  images {
    _id
    url
    name
    alt
  }
  area {
    _id
    name
  }
  author {
    _id
    fullname
  }
  contributionMode
  reservationDeadlineDays
  reservationExpiresAt
  isReserved
  isReservedByMe
  hasContributed
  publishedAt
}
    `;
export const TripLabelFragmentDoc = gql`
    fragment TripLabel on TripLabel {
  _id
  label
  color
}
    `;
export const TripPreviewItemFragmentDoc = gql`
    fragment TripPreviewItem on PublishedTrip {
  _id
  slug
  title
  coverImage {
    ...Image
  }
  area {
    _id
    name
  }
  attributes {
    accessibility
    gastro
    suitability
    additionalActivities
    overnightStay
    lengthKm
    routeType
    terrain
    duration
  }
  averageRating
  isBookmarked
  label {
    ...TripLabel
  }
  status
}
    ${ImageFragmentDoc}
${TripLabelFragmentDoc}`;
export const TripRatingFragmentDoc = gql`
    fragment TripRating on PublishedTripRating {
  _id
  score
  text
  moderationStatus
  createdAt
  user {
    _id
    shortname
    initials
  }
}
    `;
export const PartnerLocationPreviewItemFragmentDoc = gql`
    fragment PartnerLocationPreviewItem on PartnerLocationPreview {
  _id
  name
  description
  partner {
    _id
    name
  }
  images {
    ...Image
  }
  rewardCount
  rewardNames
}
    ${ImageFragmentDoc}`;
export const TripDetailFragmentDoc = gql`
    fragment TripDetail on PublishedTrip {
  _id
  slug
  status
  label {
    _id
    label
  }
  images {
    ...Image
  }
  title
  routeLink
  coordinates {
    lat
    lng
  }
  area {
    _id
    name
  }
  preview
  perex
  content
  attributes {
    accessibility
    gastro
    suitability
    additionalActivities
    overnightStay
    lengthKm
    routeType
    terrain
    duration
  }
  isBookmarked
  isFinished
  hasRated
  myRating {
    ...TripRating
  }
  averageRating
  ratings(
    pagination: {pageNumber: 1, pageSize: 2}
    sort: {field: "createdAt", direction: DESC}
  ) {
    total
    edges {
      ...TripRating
    }
  }
  author {
    _id
    shortname
  }
  authors {
    _id
    fullname
  }
  publishedAt
  partnerLocations {
    ...PartnerLocationPreviewItem
  }
}
    ${ImageFragmentDoc}
${TripRatingFragmentDoc}
${PartnerLocationPreviewItemFragmentDoc}`;
export const TripLocationFragmentDoc = gql`
    fragment TripLocation on TripLocation {
  _id
  slug
  status
  coverImage {
    ...Image
  }
  isBookmarked
  label {
    ...TripLabel
  }
  title
  preview
  coordinates {
    lat
    lng
  }
  averageRating
  attributes {
    lengthKm
    gastro
    suitability
    additionalActivities
    overnightStay
  }
}
    ${ImageFragmentDoc}
${TripLabelFragmentDoc}`;
export const RecommendedTripFragmentDoc = gql`
    fragment RecommendedTrip on RecommendedTrip {
  _id
  slug
  title
  preview
  coverImage {
    ...Image
  }
  area {
    _id
    name
  }
  label {
    ...TripLabel
  }
  averageRating
  distanceKm
  reason
  status
}
    ${ImageFragmentDoc}
${TripLabelFragmentDoc}`;
export const MeFragmentDoc = gql`
    fragment Me on User {
  _id
  fullname
  firstname
  lastname
  email
  roles
  city {
    _id
    name
  }
  sex
  ageRange
  onboardingCompleted
  hasActivePass
  language
}
    `;
export const GenerateAssetUploadDocument = gql`
    mutation GenerateAssetUpload($contentType: ContentType!) {
  generateAssetUpload(contentType: $contentType) {
    filePath
    url
  }
}
    `;

/**
 * __useGenerateAssetUploadMutation__
 *
 * To run a mutation, you first call `useGenerateAssetUploadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAssetUploadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateAssetUploadMutation({
 *   variables: {
 *     contentType: // value for 'contentType'
 *   },
 * });
 */
export function useGenerateAssetUploadMutation(options: VueApolloComposable.UseMutationOptions<IGenerateAssetUploadMutation, IGenerateAssetUploadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IGenerateAssetUploadMutation, IGenerateAssetUploadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IGenerateAssetUploadMutation, IGenerateAssetUploadMutationVariables>(GenerateAssetUploadDocument, options);
}
export type GenerateAssetUploadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IGenerateAssetUploadMutation, IGenerateAssetUploadMutationVariables>;
export const CreateAssetDocument = gql`
    mutation CreateAsset($input: AssetCreateInput!) {
  createAsset(input: $input) {
    _id
    url
    name
    alt
  }
}
    `;

/**
 * __useCreateAssetMutation__
 *
 * To run a mutation, you first call `useCreateAssetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAssetMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetMutation(options: VueApolloComposable.UseMutationOptions<ICreateAssetMutation, ICreateAssetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ICreateAssetMutation, ICreateAssetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ICreateAssetMutation, ICreateAssetMutationVariables>(CreateAssetDocument, options);
}
export type CreateAssetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ICreateAssetMutation, ICreateAssetMutationVariables>;
export const SignInDocument = gql`
    mutation SignIn($input: SignInInput!) {
  signIn(input: $input) {
    accessToken
    refreshToken
  }
}
    `;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignInMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSignInMutation(options: VueApolloComposable.UseMutationOptions<ISignInMutation, ISignInMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ISignInMutation, ISignInMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ISignInMutation, ISignInMutationVariables>(SignInDocument, options);
}
export type SignInMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ISignInMutation, ISignInMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($input: SignUpInput!) {
  signUp(input: $input)
}
    `;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignUpMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(options: VueApolloComposable.UseMutationOptions<ISignUpMutation, ISignUpMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ISignUpMutation, ISignUpMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ISignUpMutation, ISignUpMutationVariables>(SignUpDocument, options);
}
export type SignUpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ISignUpMutation, ISignUpMutationVariables>;
export const FinishSignUpDocument = gql`
    mutation FinishSignUp($input: FinishSignUpInput!) {
  finishSignUp(input: $input)
}
    `;

/**
 * __useFinishSignUpMutation__
 *
 * To run a mutation, you first call `useFinishSignUpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFinishSignUpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFinishSignUpMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useFinishSignUpMutation(options: VueApolloComposable.UseMutationOptions<IFinishSignUpMutation, IFinishSignUpMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IFinishSignUpMutation, IFinishSignUpMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IFinishSignUpMutation, IFinishSignUpMutationVariables>(FinishSignUpDocument, options);
}
export type FinishSignUpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IFinishSignUpMutation, IFinishSignUpMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: JWT!) {
  refreshToken(refreshToken: $refreshToken) {
    accessToken
  }
}
    `;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRefreshTokenMutation({
 *   variables: {
 *     refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(options: VueApolloComposable.UseMutationOptions<IRefreshTokenMutation, IRefreshTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IRefreshTokenMutation, IRefreshTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IRefreshTokenMutation, IRefreshTokenMutationVariables>(RefreshTokenDocument, options);
}
export type RefreshTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IRefreshTokenMutation, IRefreshTokenMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: EmailAddress!) {
  requestPasswordReset(email: $email)
}
    `;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestPasswordResetMutation({
 *   variables: {
 *     email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(options: VueApolloComposable.UseMutationOptions<IRequestPasswordResetMutation, IRequestPasswordResetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IRequestPasswordResetMutation, IRequestPasswordResetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IRequestPasswordResetMutation, IRequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
}
export type RequestPasswordResetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IRequestPasswordResetMutation, IRequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($code: String!, $password: String!) {
  resetPassword(code: $code, password: $password)
}
    `;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetPasswordMutation({
 *   variables: {
 *     code: // value for 'code'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(options: VueApolloComposable.UseMutationOptions<IResetPasswordMutation, IResetPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IResetPasswordMutation, IResetPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IResetPasswordMutation, IResetPasswordMutationVariables>(ResetPasswordDocument, options);
}
export type ResetPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IResetPasswordMutation, IResetPasswordMutationVariables>;
export const ToggleArticleBookmarkDocument = gql`
    mutation ToggleArticleBookmark($article: ID!) {
  toggleArticleBookmark(article: $article)
}
    `;

/**
 * __useToggleArticleBookmarkMutation__
 *
 * To run a mutation, you first call `useToggleArticleBookmarkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useToggleArticleBookmarkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useToggleArticleBookmarkMutation({
 *   variables: {
 *     article: // value for 'article'
 *   },
 * });
 */
export function useToggleArticleBookmarkMutation(options: VueApolloComposable.UseMutationOptions<IToggleArticleBookmarkMutation, IToggleArticleBookmarkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IToggleArticleBookmarkMutation, IToggleArticleBookmarkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IToggleArticleBookmarkMutation, IToggleArticleBookmarkMutationVariables>(ToggleArticleBookmarkDocument, options);
}
export type ToggleArticleBookmarkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IToggleArticleBookmarkMutation, IToggleArticleBookmarkMutationVariables>;
export const ArticlesDocument = gql`
    query Articles($language: Language, $filter: PublishedArticleFilterInput!, $pagination: PaginationInput!, $sort: SortInput) {
  articles: publishedArticles(
    language: $language
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    total
    edges {
      ...ArticlePreviewItem
    }
  }
}
    ${ArticlePreviewItemFragmentDoc}`;

/**
 * __useArticlesQuery__
 *
 * To run a query within a Vue component, call `useArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useArticlesQuery({
 *   language: // value for 'language'
 *   filter: // value for 'filter'
 *   pagination: // value for 'pagination'
 *   sort: // value for 'sort'
 * });
 */
export function useArticlesQuery(variables: IArticlesQueryVariables | VueCompositionApi.Ref<IArticlesQueryVariables> | ReactiveFunction<IArticlesQueryVariables>, options: VueApolloComposable.UseQueryOptions<IArticlesQuery, IArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IArticlesQuery, IArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IArticlesQuery, IArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IArticlesQuery, IArticlesQueryVariables>(ArticlesDocument, variables, options);
}
export function useArticlesLazyQuery(variables?: IArticlesQueryVariables | VueCompositionApi.Ref<IArticlesQueryVariables> | ReactiveFunction<IArticlesQueryVariables>, options: VueApolloComposable.UseQueryOptions<IArticlesQuery, IArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IArticlesQuery, IArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IArticlesQuery, IArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IArticlesQuery, IArticlesQueryVariables>(ArticlesDocument, variables, options);
}
export type ArticlesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IArticlesQuery, IArticlesQueryVariables>;
export const BookmarkedArticlesDocument = gql`
    query BookmarkedArticles($language: Language, $pagination: PaginationInput!) {
  myBookmarkedArticles(language: $language, pagination: $pagination) {
    total
    edges {
      ...ArticlePreviewItem
    }
  }
}
    ${ArticlePreviewItemFragmentDoc}`;

/**
 * __useBookmarkedArticlesQuery__
 *
 * To run a query within a Vue component, call `useBookmarkedArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookmarkedArticlesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBookmarkedArticlesQuery({
 *   language: // value for 'language'
 *   pagination: // value for 'pagination'
 * });
 */
export function useBookmarkedArticlesQuery(variables: IBookmarkedArticlesQueryVariables | VueCompositionApi.Ref<IBookmarkedArticlesQueryVariables> | ReactiveFunction<IBookmarkedArticlesQueryVariables>, options: VueApolloComposable.UseQueryOptions<IBookmarkedArticlesQuery, IBookmarkedArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IBookmarkedArticlesQuery, IBookmarkedArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IBookmarkedArticlesQuery, IBookmarkedArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IBookmarkedArticlesQuery, IBookmarkedArticlesQueryVariables>(BookmarkedArticlesDocument, variables, options);
}
export function useBookmarkedArticlesLazyQuery(variables?: IBookmarkedArticlesQueryVariables | VueCompositionApi.Ref<IBookmarkedArticlesQueryVariables> | ReactiveFunction<IBookmarkedArticlesQueryVariables>, options: VueApolloComposable.UseQueryOptions<IBookmarkedArticlesQuery, IBookmarkedArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IBookmarkedArticlesQuery, IBookmarkedArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IBookmarkedArticlesQuery, IBookmarkedArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IBookmarkedArticlesQuery, IBookmarkedArticlesQueryVariables>(BookmarkedArticlesDocument, variables, options);
}
export type BookmarkedArticlesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IBookmarkedArticlesQuery, IBookmarkedArticlesQueryVariables>;
export const FeedDocument = gql`
    query Feed($language: Language, $filter: PublishedArticleFilterInput!, $pagination: PaginationInput!, $sort: SortInput) {
  feed(language: $language, filter: $filter, pagination: $pagination, sort: $sort) {
    total
    edges {
      ...ArticlePreviewItem
      ...TripAnnouncementItem
    }
  }
}
    ${ArticlePreviewItemFragmentDoc}
${TripAnnouncementItemFragmentDoc}`;

/**
 * __useFeedQuery__
 *
 * To run a query within a Vue component, call `useFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFeedQuery({
 *   language: // value for 'language'
 *   filter: // value for 'filter'
 *   pagination: // value for 'pagination'
 *   sort: // value for 'sort'
 * });
 */
export function useFeedQuery(variables: IFeedQueryVariables | VueCompositionApi.Ref<IFeedQueryVariables> | ReactiveFunction<IFeedQueryVariables>, options: VueApolloComposable.UseQueryOptions<IFeedQuery, IFeedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IFeedQuery, IFeedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IFeedQuery, IFeedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IFeedQuery, IFeedQueryVariables>(FeedDocument, variables, options);
}
export function useFeedLazyQuery(variables?: IFeedQueryVariables | VueCompositionApi.Ref<IFeedQueryVariables> | ReactiveFunction<IFeedQueryVariables>, options: VueApolloComposable.UseQueryOptions<IFeedQuery, IFeedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IFeedQuery, IFeedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IFeedQuery, IFeedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IFeedQuery, IFeedQueryVariables>(FeedDocument, variables, options);
}
export type FeedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IFeedQuery, IFeedQueryVariables>;
export const ArticleDetailDocument = gql`
    query ArticleDetail($language: Language, $slug: Slug!, $skipFeatured: Boolean!) {
  featuredArticles(language: $language) @skip(if: $skipFeatured) {
    ...ArticlePreviewItem
  }
  article: publishedArticle(language: $language, slug: $slug) {
    _id
    slug
    label {
      ...PublishableLabel
    }
    title
    preview
    perex
    content
    image {
      ...Image
    }
    publishedAt
    author {
      _id
      shortname
    }
    isBookmarked
    status
  }
}
    ${ArticlePreviewItemFragmentDoc}
${PublishableLabelFragmentDoc}
${ImageFragmentDoc}`;

/**
 * __useArticleDetailQuery__
 *
 * To run a query within a Vue component, call `useArticleDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useArticleDetailQuery({
 *   language: // value for 'language'
 *   slug: // value for 'slug'
 *   skipFeatured: // value for 'skipFeatured'
 * });
 */
export function useArticleDetailQuery(variables: IArticleDetailQueryVariables | VueCompositionApi.Ref<IArticleDetailQueryVariables> | ReactiveFunction<IArticleDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<IArticleDetailQuery, IArticleDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IArticleDetailQuery, IArticleDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IArticleDetailQuery, IArticleDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IArticleDetailQuery, IArticleDetailQueryVariables>(ArticleDetailDocument, variables, options);
}
export function useArticleDetailLazyQuery(variables?: IArticleDetailQueryVariables | VueCompositionApi.Ref<IArticleDetailQueryVariables> | ReactiveFunction<IArticleDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<IArticleDetailQuery, IArticleDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IArticleDetailQuery, IArticleDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IArticleDetailQuery, IArticleDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IArticleDetailQuery, IArticleDetailQueryVariables>(ArticleDetailDocument, variables, options);
}
export type ArticleDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IArticleDetailQuery, IArticleDetailQueryVariables>;
export const SubscribeToNewsletterDocument = gql`
    mutation SubscribeToNewsletter($email: EmailAddress!) {
  subscribeToNewsletter(email: $email)
}
    `;

/**
 * __useSubscribeToNewsletterMutation__
 *
 * To run a mutation, you first call `useSubscribeToNewsletterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToNewsletterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubscribeToNewsletterMutation({
 *   variables: {
 *     email: // value for 'email'
 *   },
 * });
 */
export function useSubscribeToNewsletterMutation(options: VueApolloComposable.UseMutationOptions<ISubscribeToNewsletterMutation, ISubscribeToNewsletterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ISubscribeToNewsletterMutation, ISubscribeToNewsletterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ISubscribeToNewsletterMutation, ISubscribeToNewsletterMutationVariables>(SubscribeToNewsletterDocument, options);
}
export type SubscribeToNewsletterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ISubscribeToNewsletterMutation, ISubscribeToNewsletterMutationVariables>;
export const ContentPreviewsDocument = gql`
    query ContentPreviews($tripIds: [ID!], $articleIds: [ID!]) {
  contentPreviews(tripIds: $tripIds, articleIds: $articleIds) {
    _id
    contentType
    slug
    title
    imageUrl
    preview
  }
}
    `;

/**
 * __useContentPreviewsQuery__
 *
 * To run a query within a Vue component, call `useContentPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentPreviewsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContentPreviewsQuery({
 *   tripIds: // value for 'tripIds'
 *   articleIds: // value for 'articleIds'
 * });
 */
export function useContentPreviewsQuery(variables: IContentPreviewsQueryVariables | VueCompositionApi.Ref<IContentPreviewsQueryVariables> | ReactiveFunction<IContentPreviewsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<IContentPreviewsQuery, IContentPreviewsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IContentPreviewsQuery, IContentPreviewsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IContentPreviewsQuery, IContentPreviewsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IContentPreviewsQuery, IContentPreviewsQueryVariables>(ContentPreviewsDocument, variables, options);
}
export function useContentPreviewsLazyQuery(variables: IContentPreviewsQueryVariables | VueCompositionApi.Ref<IContentPreviewsQueryVariables> | ReactiveFunction<IContentPreviewsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<IContentPreviewsQuery, IContentPreviewsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IContentPreviewsQuery, IContentPreviewsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IContentPreviewsQuery, IContentPreviewsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IContentPreviewsQuery, IContentPreviewsQueryVariables>(ContentPreviewsDocument, variables, options);
}
export type ContentPreviewsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IContentPreviewsQuery, IContentPreviewsQueryVariables>;
export const CitiesDocument = gql`
    query Cities($filter: CityFilterInput!) {
  cities(filter: $filter) {
    _id
    name
    region
  }
}
    `;

/**
 * __useCitiesQuery__
 *
 * To run a query within a Vue component, call `useCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCitiesQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useCitiesQuery(variables: ICitiesQueryVariables | VueCompositionApi.Ref<ICitiesQueryVariables> | ReactiveFunction<ICitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ICitiesQuery, ICitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ICitiesQuery, ICitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ICitiesQuery, ICitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ICitiesQuery, ICitiesQueryVariables>(CitiesDocument, variables, options);
}
export function useCitiesLazyQuery(variables?: ICitiesQueryVariables | VueCompositionApi.Ref<ICitiesQueryVariables> | ReactiveFunction<ICitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ICitiesQuery, ICitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ICitiesQuery, ICitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ICitiesQuery, ICitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ICitiesQuery, ICitiesQueryVariables>(CitiesDocument, variables, options);
}
export type CitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ICitiesQuery, ICitiesQueryVariables>;
export const PartnerLocationDetailDocument = gql`
    query PartnerLocationDetail($language: Language, $id: ID!) {
  partnerLocationDetail(language: $language, id: $id) {
    ...PartnerLocationDetail
  }
}
    ${PartnerLocationDetailFragmentDoc}`;

/**
 * __usePartnerLocationDetailQuery__
 *
 * To run a query within a Vue component, call `usePartnerLocationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerLocationDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePartnerLocationDetailQuery({
 *   language: // value for 'language'
 *   id: // value for 'id'
 * });
 */
export function usePartnerLocationDetailQuery(variables: IPartnerLocationDetailQueryVariables | VueCompositionApi.Ref<IPartnerLocationDetailQueryVariables> | ReactiveFunction<IPartnerLocationDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<IPartnerLocationDetailQuery, IPartnerLocationDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IPartnerLocationDetailQuery, IPartnerLocationDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IPartnerLocationDetailQuery, IPartnerLocationDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IPartnerLocationDetailQuery, IPartnerLocationDetailQueryVariables>(PartnerLocationDetailDocument, variables, options);
}
export function usePartnerLocationDetailLazyQuery(variables?: IPartnerLocationDetailQueryVariables | VueCompositionApi.Ref<IPartnerLocationDetailQueryVariables> | ReactiveFunction<IPartnerLocationDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<IPartnerLocationDetailQuery, IPartnerLocationDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IPartnerLocationDetailQuery, IPartnerLocationDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IPartnerLocationDetailQuery, IPartnerLocationDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IPartnerLocationDetailQuery, IPartnerLocationDetailQueryVariables>(PartnerLocationDetailDocument, variables, options);
}
export type PartnerLocationDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IPartnerLocationDetailQuery, IPartnerLocationDetailQueryVariables>;
export const AreasDocument = gql`
    query Areas($language: Language) {
  areas: areaSelectOptions(language: $language) {
    value
    label
  }
}
    `;

/**
 * __useAreasQuery__
 *
 * To run a query within a Vue component, call `useAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreasQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAreasQuery({
 *   language: // value for 'language'
 * });
 */
export function useAreasQuery(variables: IAreasQueryVariables | VueCompositionApi.Ref<IAreasQueryVariables> | ReactiveFunction<IAreasQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<IAreasQuery, IAreasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IAreasQuery, IAreasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IAreasQuery, IAreasQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IAreasQuery, IAreasQueryVariables>(AreasDocument, variables, options);
}
export function useAreasLazyQuery(variables: IAreasQueryVariables | VueCompositionApi.Ref<IAreasQueryVariables> | ReactiveFunction<IAreasQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<IAreasQuery, IAreasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IAreasQuery, IAreasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IAreasQuery, IAreasQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IAreasQuery, IAreasQueryVariables>(AreasDocument, variables, options);
}
export type AreasQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IAreasQuery, IAreasQueryVariables>;
export const ReserveTripSuggestionDocument = gql`
    mutation ReserveTripSuggestion($id: ID!) {
  reserveTripSuggestion(id: $id) {
    _id
    status
    reservationExpiresAt
    isReserved
    isReservedByMe
  }
}
    `;

/**
 * __useReserveTripSuggestionMutation__
 *
 * To run a mutation, you first call `useReserveTripSuggestionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReserveTripSuggestionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReserveTripSuggestionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useReserveTripSuggestionMutation(options: VueApolloComposable.UseMutationOptions<IReserveTripSuggestionMutation, IReserveTripSuggestionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IReserveTripSuggestionMutation, IReserveTripSuggestionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IReserveTripSuggestionMutation, IReserveTripSuggestionMutationVariables>(ReserveTripSuggestionDocument, options);
}
export type ReserveTripSuggestionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IReserveTripSuggestionMutation, IReserveTripSuggestionMutationVariables>;
export const CancelMyTripSuggestionReservationDocument = gql`
    mutation CancelMyTripSuggestionReservation($id: ID!) {
  cancelMyTripSuggestionReservation(id: $id) {
    _id
    status
    isReserved
    isReservedByMe
  }
}
    `;

/**
 * __useCancelMyTripSuggestionReservationMutation__
 *
 * To run a mutation, you first call `useCancelMyTripSuggestionReservationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelMyTripSuggestionReservationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelMyTripSuggestionReservationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCancelMyTripSuggestionReservationMutation(options: VueApolloComposable.UseMutationOptions<ICancelMyTripSuggestionReservationMutation, ICancelMyTripSuggestionReservationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ICancelMyTripSuggestionReservationMutation, ICancelMyTripSuggestionReservationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ICancelMyTripSuggestionReservationMutation, ICancelMyTripSuggestionReservationMutationVariables>(CancelMyTripSuggestionReservationDocument, options);
}
export type CancelMyTripSuggestionReservationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ICancelMyTripSuggestionReservationMutation, ICancelMyTripSuggestionReservationMutationVariables>;
export const SubmitTripSuggestionContributionDocument = gql`
    mutation SubmitTripSuggestionContribution($id: ID!, $input: TripSuggestionContributionInput!) {
  submitTripSuggestionContribution(id: $id, input: $input) {
    _id
    status
    hasContributed
  }
}
    `;

/**
 * __useSubmitTripSuggestionContributionMutation__
 *
 * To run a mutation, you first call `useSubmitTripSuggestionContributionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTripSuggestionContributionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitTripSuggestionContributionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSubmitTripSuggestionContributionMutation(options: VueApolloComposable.UseMutationOptions<ISubmitTripSuggestionContributionMutation, ISubmitTripSuggestionContributionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ISubmitTripSuggestionContributionMutation, ISubmitTripSuggestionContributionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ISubmitTripSuggestionContributionMutation, ISubmitTripSuggestionContributionMutationVariables>(SubmitTripSuggestionContributionDocument, options);
}
export type SubmitTripSuggestionContributionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ISubmitTripSuggestionContributionMutation, ISubmitTripSuggestionContributionMutationVariables>;
export const PublishedTripSuggestionDocument = gql`
    query PublishedTripSuggestion($id: ID!) {
  publishedTripSuggestion(id: $id) {
    ...PublishedTripSuggestionDetail
  }
}
    ${PublishedTripSuggestionDetailFragmentDoc}`;

/**
 * __usePublishedTripSuggestionQuery__
 *
 * To run a query within a Vue component, call `usePublishedTripSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedTripSuggestionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePublishedTripSuggestionQuery({
 *   id: // value for 'id'
 * });
 */
export function usePublishedTripSuggestionQuery(variables: IPublishedTripSuggestionQueryVariables | VueCompositionApi.Ref<IPublishedTripSuggestionQueryVariables> | ReactiveFunction<IPublishedTripSuggestionQueryVariables>, options: VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionQuery, IPublishedTripSuggestionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionQuery, IPublishedTripSuggestionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionQuery, IPublishedTripSuggestionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IPublishedTripSuggestionQuery, IPublishedTripSuggestionQueryVariables>(PublishedTripSuggestionDocument, variables, options);
}
export function usePublishedTripSuggestionLazyQuery(variables?: IPublishedTripSuggestionQueryVariables | VueCompositionApi.Ref<IPublishedTripSuggestionQueryVariables> | ReactiveFunction<IPublishedTripSuggestionQueryVariables>, options: VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionQuery, IPublishedTripSuggestionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionQuery, IPublishedTripSuggestionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionQuery, IPublishedTripSuggestionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IPublishedTripSuggestionQuery, IPublishedTripSuggestionQueryVariables>(PublishedTripSuggestionDocument, variables, options);
}
export type PublishedTripSuggestionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IPublishedTripSuggestionQuery, IPublishedTripSuggestionQueryVariables>;
export const PublishedTripSuggestionLocationsDocument = gql`
    query PublishedTripSuggestionLocations($filter: PublishedTripSuggestionFilterInput) {
  publishedTripSuggestionLocations(filter: $filter) {
    _id
    title
    status
    isReserved
    coordinates {
      lat
      lng
    }
  }
}
    `;

/**
 * __usePublishedTripSuggestionLocationsQuery__
 *
 * To run a query within a Vue component, call `usePublishedTripSuggestionLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedTripSuggestionLocationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePublishedTripSuggestionLocationsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function usePublishedTripSuggestionLocationsQuery(variables: IPublishedTripSuggestionLocationsQueryVariables | VueCompositionApi.Ref<IPublishedTripSuggestionLocationsQueryVariables> | ReactiveFunction<IPublishedTripSuggestionLocationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionLocationsQuery, IPublishedTripSuggestionLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionLocationsQuery, IPublishedTripSuggestionLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionLocationsQuery, IPublishedTripSuggestionLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IPublishedTripSuggestionLocationsQuery, IPublishedTripSuggestionLocationsQueryVariables>(PublishedTripSuggestionLocationsDocument, variables, options);
}
export function usePublishedTripSuggestionLocationsLazyQuery(variables: IPublishedTripSuggestionLocationsQueryVariables | VueCompositionApi.Ref<IPublishedTripSuggestionLocationsQueryVariables> | ReactiveFunction<IPublishedTripSuggestionLocationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionLocationsQuery, IPublishedTripSuggestionLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionLocationsQuery, IPublishedTripSuggestionLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IPublishedTripSuggestionLocationsQuery, IPublishedTripSuggestionLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IPublishedTripSuggestionLocationsQuery, IPublishedTripSuggestionLocationsQueryVariables>(PublishedTripSuggestionLocationsDocument, variables, options);
}
export type PublishedTripSuggestionLocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IPublishedTripSuggestionLocationsQuery, IPublishedTripSuggestionLocationsQueryVariables>;
export const FilteredTripSuggestionsCountDocument = gql`
    query FilteredTripSuggestionsCount($filter: PublishedTripSuggestionFilterInput) {
  count: publishedTripSuggestionsResultsCount(filter: $filter)
}
    `;

/**
 * __useFilteredTripSuggestionsCountQuery__
 *
 * To run a query within a Vue component, call `useFilteredTripSuggestionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTripSuggestionsCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFilteredTripSuggestionsCountQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useFilteredTripSuggestionsCountQuery(variables: IFilteredTripSuggestionsCountQueryVariables | VueCompositionApi.Ref<IFilteredTripSuggestionsCountQueryVariables> | ReactiveFunction<IFilteredTripSuggestionsCountQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<IFilteredTripSuggestionsCountQuery, IFilteredTripSuggestionsCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IFilteredTripSuggestionsCountQuery, IFilteredTripSuggestionsCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IFilteredTripSuggestionsCountQuery, IFilteredTripSuggestionsCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IFilteredTripSuggestionsCountQuery, IFilteredTripSuggestionsCountQueryVariables>(FilteredTripSuggestionsCountDocument, variables, options);
}
export function useFilteredTripSuggestionsCountLazyQuery(variables: IFilteredTripSuggestionsCountQueryVariables | VueCompositionApi.Ref<IFilteredTripSuggestionsCountQueryVariables> | ReactiveFunction<IFilteredTripSuggestionsCountQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<IFilteredTripSuggestionsCountQuery, IFilteredTripSuggestionsCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IFilteredTripSuggestionsCountQuery, IFilteredTripSuggestionsCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IFilteredTripSuggestionsCountQuery, IFilteredTripSuggestionsCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IFilteredTripSuggestionsCountQuery, IFilteredTripSuggestionsCountQueryVariables>(FilteredTripSuggestionsCountDocument, variables, options);
}
export type FilteredTripSuggestionsCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IFilteredTripSuggestionsCountQuery, IFilteredTripSuggestionsCountQueryVariables>;
export const MyReservedTripSuggestionsDocument = gql`
    query MyReservedTripSuggestions {
  myReservedTripSuggestions {
    ...PublishedTripSuggestionDetail
  }
}
    ${PublishedTripSuggestionDetailFragmentDoc}`;

/**
 * __useMyReservedTripSuggestionsQuery__
 *
 * To run a query within a Vue component, call `useMyReservedTripSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyReservedTripSuggestionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyReservedTripSuggestionsQuery();
 */
export function useMyReservedTripSuggestionsQuery(options: VueApolloComposable.UseQueryOptions<IMyReservedTripSuggestionsQuery, IMyReservedTripSuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IMyReservedTripSuggestionsQuery, IMyReservedTripSuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IMyReservedTripSuggestionsQuery, IMyReservedTripSuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IMyReservedTripSuggestionsQuery, IMyReservedTripSuggestionsQueryVariables>(MyReservedTripSuggestionsDocument, {}, options);
}
export function useMyReservedTripSuggestionsLazyQuery(options: VueApolloComposable.UseQueryOptions<IMyReservedTripSuggestionsQuery, IMyReservedTripSuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IMyReservedTripSuggestionsQuery, IMyReservedTripSuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IMyReservedTripSuggestionsQuery, IMyReservedTripSuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IMyReservedTripSuggestionsQuery, IMyReservedTripSuggestionsQueryVariables>(MyReservedTripSuggestionsDocument, {}, options);
}
export type MyReservedTripSuggestionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IMyReservedTripSuggestionsQuery, IMyReservedTripSuggestionsQueryVariables>;
export const MyContributedTripSuggestionsDocument = gql`
    query MyContributedTripSuggestions {
  myContributedTripSuggestions {
    ...PublishedTripSuggestionDetail
  }
}
    ${PublishedTripSuggestionDetailFragmentDoc}`;

/**
 * __useMyContributedTripSuggestionsQuery__
 *
 * To run a query within a Vue component, call `useMyContributedTripSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyContributedTripSuggestionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyContributedTripSuggestionsQuery();
 */
export function useMyContributedTripSuggestionsQuery(options: VueApolloComposable.UseQueryOptions<IMyContributedTripSuggestionsQuery, IMyContributedTripSuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IMyContributedTripSuggestionsQuery, IMyContributedTripSuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IMyContributedTripSuggestionsQuery, IMyContributedTripSuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IMyContributedTripSuggestionsQuery, IMyContributedTripSuggestionsQueryVariables>(MyContributedTripSuggestionsDocument, {}, options);
}
export function useMyContributedTripSuggestionsLazyQuery(options: VueApolloComposable.UseQueryOptions<IMyContributedTripSuggestionsQuery, IMyContributedTripSuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IMyContributedTripSuggestionsQuery, IMyContributedTripSuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IMyContributedTripSuggestionsQuery, IMyContributedTripSuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IMyContributedTripSuggestionsQuery, IMyContributedTripSuggestionsQueryVariables>(MyContributedTripSuggestionsDocument, {}, options);
}
export type MyContributedTripSuggestionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IMyContributedTripSuggestionsQuery, IMyContributedTripSuggestionsQueryVariables>;
export const RateTripDocument = gql`
    mutation RateTrip($id: ID!, $input: TripRatingCreateInput!) {
  rateTrip(id: $id, input: $input)
}
    `;

/**
 * __useRateTripMutation__
 *
 * To run a mutation, you first call `useRateTripMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRateTripMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRateTripMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRateTripMutation(options: VueApolloComposable.UseMutationOptions<IRateTripMutation, IRateTripMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IRateTripMutation, IRateTripMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IRateTripMutation, IRateTripMutationVariables>(RateTripDocument, options);
}
export type RateTripMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IRateTripMutation, IRateTripMutationVariables>;
export const ToggleTripBookmarkDocument = gql`
    mutation ToggleTripBookmark($trip: ID!) {
  toggleTripBookmark(trip: $trip)
}
    `;

/**
 * __useToggleTripBookmarkMutation__
 *
 * To run a mutation, you first call `useToggleTripBookmarkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useToggleTripBookmarkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useToggleTripBookmarkMutation({
 *   variables: {
 *     trip: // value for 'trip'
 *   },
 * });
 */
export function useToggleTripBookmarkMutation(options: VueApolloComposable.UseMutationOptions<IToggleTripBookmarkMutation, IToggleTripBookmarkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IToggleTripBookmarkMutation, IToggleTripBookmarkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IToggleTripBookmarkMutation, IToggleTripBookmarkMutationVariables>(ToggleTripBookmarkDocument, options);
}
export type ToggleTripBookmarkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IToggleTripBookmarkMutation, IToggleTripBookmarkMutationVariables>;
export const ToggleTripFinishedDocument = gql`
    mutation ToggleTripFinished($trip: ID!) {
  toggleTripFinished(trip: $trip)
}
    `;

/**
 * __useToggleTripFinishedMutation__
 *
 * To run a mutation, you first call `useToggleTripFinishedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useToggleTripFinishedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useToggleTripFinishedMutation({
 *   variables: {
 *     trip: // value for 'trip'
 *   },
 * });
 */
export function useToggleTripFinishedMutation(options: VueApolloComposable.UseMutationOptions<IToggleTripFinishedMutation, IToggleTripFinishedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IToggleTripFinishedMutation, IToggleTripFinishedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IToggleTripFinishedMutation, IToggleTripFinishedMutationVariables>(ToggleTripFinishedDocument, options);
}
export type ToggleTripFinishedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IToggleTripFinishedMutation, IToggleTripFinishedMutationVariables>;
export const RecommendedTripsDocument = gql`
    query RecommendedTrips($language: Language, $options: RecommendationOptionsInput) {
  recommendedTrips(language: $language, options: $options) {
    ...RecommendedTrip
  }
}
    ${RecommendedTripFragmentDoc}`;

/**
 * __useRecommendedTripsQuery__
 *
 * To run a query within a Vue component, call `useRecommendedTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedTripsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRecommendedTripsQuery({
 *   language: // value for 'language'
 *   options: // value for 'options'
 * });
 */
export function useRecommendedTripsQuery(variables: IRecommendedTripsQueryVariables | VueCompositionApi.Ref<IRecommendedTripsQueryVariables> | ReactiveFunction<IRecommendedTripsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<IRecommendedTripsQuery, IRecommendedTripsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IRecommendedTripsQuery, IRecommendedTripsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IRecommendedTripsQuery, IRecommendedTripsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IRecommendedTripsQuery, IRecommendedTripsQueryVariables>(RecommendedTripsDocument, variables, options);
}
export function useRecommendedTripsLazyQuery(variables: IRecommendedTripsQueryVariables | VueCompositionApi.Ref<IRecommendedTripsQueryVariables> | ReactiveFunction<IRecommendedTripsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<IRecommendedTripsQuery, IRecommendedTripsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IRecommendedTripsQuery, IRecommendedTripsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IRecommendedTripsQuery, IRecommendedTripsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IRecommendedTripsQuery, IRecommendedTripsQueryVariables>(RecommendedTripsDocument, variables, options);
}
export type RecommendedTripsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IRecommendedTripsQuery, IRecommendedTripsQueryVariables>;
export const TripsDocument = gql`
    query Trips($language: Language, $filter: PublishedTripFilterInput!, $pagination: PaginationInput!, $sort: SortInput) {
  trips: publishedTrips(
    language: $language
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    total
    edges {
      ...TripPreviewItem
    }
  }
}
    ${TripPreviewItemFragmentDoc}`;

/**
 * __useTripsQuery__
 *
 * To run a query within a Vue component, call `useTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTripsQuery({
 *   language: // value for 'language'
 *   filter: // value for 'filter'
 *   pagination: // value for 'pagination'
 *   sort: // value for 'sort'
 * });
 */
export function useTripsQuery(variables: ITripsQueryVariables | VueCompositionApi.Ref<ITripsQueryVariables> | ReactiveFunction<ITripsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ITripsQuery, ITripsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ITripsQuery, ITripsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ITripsQuery, ITripsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ITripsQuery, ITripsQueryVariables>(TripsDocument, variables, options);
}
export function useTripsLazyQuery(variables?: ITripsQueryVariables | VueCompositionApi.Ref<ITripsQueryVariables> | ReactiveFunction<ITripsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ITripsQuery, ITripsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ITripsQuery, ITripsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ITripsQuery, ITripsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ITripsQuery, ITripsQueryVariables>(TripsDocument, variables, options);
}
export type TripsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ITripsQuery, ITripsQueryVariables>;
export const BookmarkedTripsDocument = gql`
    query BookmarkedTrips($language: Language, $pagination: PaginationInput!) {
  myBookmarkedTrips(language: $language, pagination: $pagination) {
    total
    edges {
      ...TripPreviewItem
    }
  }
}
    ${TripPreviewItemFragmentDoc}`;

/**
 * __useBookmarkedTripsQuery__
 *
 * To run a query within a Vue component, call `useBookmarkedTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookmarkedTripsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBookmarkedTripsQuery({
 *   language: // value for 'language'
 *   pagination: // value for 'pagination'
 * });
 */
export function useBookmarkedTripsQuery(variables: IBookmarkedTripsQueryVariables | VueCompositionApi.Ref<IBookmarkedTripsQueryVariables> | ReactiveFunction<IBookmarkedTripsQueryVariables>, options: VueApolloComposable.UseQueryOptions<IBookmarkedTripsQuery, IBookmarkedTripsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IBookmarkedTripsQuery, IBookmarkedTripsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IBookmarkedTripsQuery, IBookmarkedTripsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IBookmarkedTripsQuery, IBookmarkedTripsQueryVariables>(BookmarkedTripsDocument, variables, options);
}
export function useBookmarkedTripsLazyQuery(variables?: IBookmarkedTripsQueryVariables | VueCompositionApi.Ref<IBookmarkedTripsQueryVariables> | ReactiveFunction<IBookmarkedTripsQueryVariables>, options: VueApolloComposable.UseQueryOptions<IBookmarkedTripsQuery, IBookmarkedTripsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IBookmarkedTripsQuery, IBookmarkedTripsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IBookmarkedTripsQuery, IBookmarkedTripsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IBookmarkedTripsQuery, IBookmarkedTripsQueryVariables>(BookmarkedTripsDocument, variables, options);
}
export type BookmarkedTripsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IBookmarkedTripsQuery, IBookmarkedTripsQueryVariables>;
export const FinishedTripsDocument = gql`
    query FinishedTrips($language: Language, $pagination: PaginationInput!) {
  myFinishedTrips(language: $language, pagination: $pagination) {
    total
    totalKm
    edges {
      ...TripPreviewItem
    }
  }
}
    ${TripPreviewItemFragmentDoc}`;

/**
 * __useFinishedTripsQuery__
 *
 * To run a query within a Vue component, call `useFinishedTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishedTripsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFinishedTripsQuery({
 *   language: // value for 'language'
 *   pagination: // value for 'pagination'
 * });
 */
export function useFinishedTripsQuery(variables: IFinishedTripsQueryVariables | VueCompositionApi.Ref<IFinishedTripsQueryVariables> | ReactiveFunction<IFinishedTripsQueryVariables>, options: VueApolloComposable.UseQueryOptions<IFinishedTripsQuery, IFinishedTripsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IFinishedTripsQuery, IFinishedTripsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IFinishedTripsQuery, IFinishedTripsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IFinishedTripsQuery, IFinishedTripsQueryVariables>(FinishedTripsDocument, variables, options);
}
export function useFinishedTripsLazyQuery(variables?: IFinishedTripsQueryVariables | VueCompositionApi.Ref<IFinishedTripsQueryVariables> | ReactiveFunction<IFinishedTripsQueryVariables>, options: VueApolloComposable.UseQueryOptions<IFinishedTripsQuery, IFinishedTripsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IFinishedTripsQuery, IFinishedTripsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IFinishedTripsQuery, IFinishedTripsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IFinishedTripsQuery, IFinishedTripsQueryVariables>(FinishedTripsDocument, variables, options);
}
export type FinishedTripsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IFinishedTripsQuery, IFinishedTripsQueryVariables>;
export const FilteredTripsCountDocument = gql`
    query FilteredTripsCount($filter: PublishedTripFilterInput!) {
  count: publishedTripsResultsCount(filter: $filter)
}
    `;

/**
 * __useFilteredTripsCountQuery__
 *
 * To run a query within a Vue component, call `useFilteredTripsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTripsCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFilteredTripsCountQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useFilteredTripsCountQuery(variables: IFilteredTripsCountQueryVariables | VueCompositionApi.Ref<IFilteredTripsCountQueryVariables> | ReactiveFunction<IFilteredTripsCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<IFilteredTripsCountQuery, IFilteredTripsCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IFilteredTripsCountQuery, IFilteredTripsCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IFilteredTripsCountQuery, IFilteredTripsCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IFilteredTripsCountQuery, IFilteredTripsCountQueryVariables>(FilteredTripsCountDocument, variables, options);
}
export function useFilteredTripsCountLazyQuery(variables?: IFilteredTripsCountQueryVariables | VueCompositionApi.Ref<IFilteredTripsCountQueryVariables> | ReactiveFunction<IFilteredTripsCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<IFilteredTripsCountQuery, IFilteredTripsCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IFilteredTripsCountQuery, IFilteredTripsCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IFilteredTripsCountQuery, IFilteredTripsCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IFilteredTripsCountQuery, IFilteredTripsCountQueryVariables>(FilteredTripsCountDocument, variables, options);
}
export type FilteredTripsCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IFilteredTripsCountQuery, IFilteredTripsCountQueryVariables>;
export const TripPreviewDocument = gql`
    query TripPreview($language: Language, $slug: Slug!) {
  trip: publishedTrip(language: $language, slug: $slug) {
    ...TripPreviewItem
  }
}
    ${TripPreviewItemFragmentDoc}`;

/**
 * __useTripPreviewQuery__
 *
 * To run a query within a Vue component, call `useTripPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripPreviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTripPreviewQuery({
 *   language: // value for 'language'
 *   slug: // value for 'slug'
 * });
 */
export function useTripPreviewQuery(variables: ITripPreviewQueryVariables | VueCompositionApi.Ref<ITripPreviewQueryVariables> | ReactiveFunction<ITripPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<ITripPreviewQuery, ITripPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ITripPreviewQuery, ITripPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ITripPreviewQuery, ITripPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ITripPreviewQuery, ITripPreviewQueryVariables>(TripPreviewDocument, variables, options);
}
export function useTripPreviewLazyQuery(variables?: ITripPreviewQueryVariables | VueCompositionApi.Ref<ITripPreviewQueryVariables> | ReactiveFunction<ITripPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<ITripPreviewQuery, ITripPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ITripPreviewQuery, ITripPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ITripPreviewQuery, ITripPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ITripPreviewQuery, ITripPreviewQueryVariables>(TripPreviewDocument, variables, options);
}
export type TripPreviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ITripPreviewQuery, ITripPreviewQueryVariables>;
export const TripDetailDocument = gql`
    query TripDetail($language: Language, $slug: Slug!) {
  trip: publishedTrip(language: $language, slug: $slug) {
    ...TripDetail
  }
}
    ${TripDetailFragmentDoc}`;

/**
 * __useTripDetailQuery__
 *
 * To run a query within a Vue component, call `useTripDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTripDetailQuery({
 *   language: // value for 'language'
 *   slug: // value for 'slug'
 * });
 */
export function useTripDetailQuery(variables: ITripDetailQueryVariables | VueCompositionApi.Ref<ITripDetailQueryVariables> | ReactiveFunction<ITripDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<ITripDetailQuery, ITripDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ITripDetailQuery, ITripDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ITripDetailQuery, ITripDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ITripDetailQuery, ITripDetailQueryVariables>(TripDetailDocument, variables, options);
}
export function useTripDetailLazyQuery(variables?: ITripDetailQueryVariables | VueCompositionApi.Ref<ITripDetailQueryVariables> | ReactiveFunction<ITripDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<ITripDetailQuery, ITripDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ITripDetailQuery, ITripDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ITripDetailQuery, ITripDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ITripDetailQuery, ITripDetailQueryVariables>(TripDetailDocument, variables, options);
}
export type TripDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ITripDetailQuery, ITripDetailQueryVariables>;
export const SimilarTripsDocument = gql`
    query SimilarTrips($language: Language, $tripId: ID!, $limit: Int) {
  similarTrips(language: $language, tripId: $tripId, limit: $limit) {
    ...RecommendedTrip
  }
}
    ${RecommendedTripFragmentDoc}`;

/**
 * __useSimilarTripsQuery__
 *
 * To run a query within a Vue component, call `useSimilarTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarTripsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSimilarTripsQuery({
 *   language: // value for 'language'
 *   tripId: // value for 'tripId'
 *   limit: // value for 'limit'
 * });
 */
export function useSimilarTripsQuery(variables: ISimilarTripsQueryVariables | VueCompositionApi.Ref<ISimilarTripsQueryVariables> | ReactiveFunction<ISimilarTripsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ISimilarTripsQuery, ISimilarTripsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ISimilarTripsQuery, ISimilarTripsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ISimilarTripsQuery, ISimilarTripsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ISimilarTripsQuery, ISimilarTripsQueryVariables>(SimilarTripsDocument, variables, options);
}
export function useSimilarTripsLazyQuery(variables?: ISimilarTripsQueryVariables | VueCompositionApi.Ref<ISimilarTripsQueryVariables> | ReactiveFunction<ISimilarTripsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ISimilarTripsQuery, ISimilarTripsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ISimilarTripsQuery, ISimilarTripsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ISimilarTripsQuery, ISimilarTripsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ISimilarTripsQuery, ISimilarTripsQueryVariables>(SimilarTripsDocument, variables, options);
}
export type SimilarTripsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ISimilarTripsQuery, ISimilarTripsQueryVariables>;
export const TripsLocationsDocument = gql`
    query TripsLocations($language: Language, $filter: PublishedTripFilterInput!) {
  tripsLocations(language: $language, filter: $filter) {
    ...TripLocation
  }
}
    ${TripLocationFragmentDoc}`;

/**
 * __useTripsLocationsQuery__
 *
 * To run a query within a Vue component, call `useTripsLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripsLocationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTripsLocationsQuery({
 *   language: // value for 'language'
 *   filter: // value for 'filter'
 * });
 */
export function useTripsLocationsQuery(variables: ITripsLocationsQueryVariables | VueCompositionApi.Ref<ITripsLocationsQueryVariables> | ReactiveFunction<ITripsLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ITripsLocationsQuery, ITripsLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ITripsLocationsQuery, ITripsLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ITripsLocationsQuery, ITripsLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ITripsLocationsQuery, ITripsLocationsQueryVariables>(TripsLocationsDocument, variables, options);
}
export function useTripsLocationsLazyQuery(variables?: ITripsLocationsQueryVariables | VueCompositionApi.Ref<ITripsLocationsQueryVariables> | ReactiveFunction<ITripsLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ITripsLocationsQuery, ITripsLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ITripsLocationsQuery, ITripsLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ITripsLocationsQuery, ITripsLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ITripsLocationsQuery, ITripsLocationsQueryVariables>(TripsLocationsDocument, variables, options);
}
export type TripsLocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ITripsLocationsQuery, ITripsLocationsQueryVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(oldPassword: $oldPassword, newPassword: $newPassword)
}
    `;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangePasswordMutation({
 *   variables: {
 *     oldPassword: // value for 'oldPassword'
 *     newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(options: VueApolloComposable.UseMutationOptions<IChangePasswordMutation, IChangePasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IChangePasswordMutation, IChangePasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IChangePasswordMutation, IChangePasswordMutationVariables>(ChangePasswordDocument, options);
}
export type ChangePasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IChangePasswordMutation, IChangePasswordMutationVariables>;
export const UpdateMyProfileDocument = gql`
    mutation UpdateMyProfile($input: UpdateMyProfileInput!) {
  updateMyProfile(input: $input) {
    _id
  }
}
    `;

/**
 * __useUpdateMyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateMyProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMyProfileMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyProfileMutation(options: VueApolloComposable.UseMutationOptions<IUpdateMyProfileMutation, IUpdateMyProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IUpdateMyProfileMutation, IUpdateMyProfileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IUpdateMyProfileMutation, IUpdateMyProfileMutationVariables>(UpdateMyProfileDocument, options);
}
export type UpdateMyProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IUpdateMyProfileMutation, IUpdateMyProfileMutationVariables>;
export const UpdateOnboardingPreferencesDocument = gql`
    mutation UpdateOnboardingPreferences($input: OnboardingPreferencesInput!) {
  updateOnboardingPreferences(input: $input)
}
    `;

/**
 * __useUpdateOnboardingPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingPreferencesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingPreferencesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOnboardingPreferencesMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOnboardingPreferencesMutation(options: VueApolloComposable.UseMutationOptions<IUpdateOnboardingPreferencesMutation, IUpdateOnboardingPreferencesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IUpdateOnboardingPreferencesMutation, IUpdateOnboardingPreferencesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IUpdateOnboardingPreferencesMutation, IUpdateOnboardingPreferencesMutationVariables>(UpdateOnboardingPreferencesDocument, options);
}
export type UpdateOnboardingPreferencesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IUpdateOnboardingPreferencesMutation, IUpdateOnboardingPreferencesMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount {
  deleteAccount
}
    `;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAccountMutation();
 */
export function useDeleteAccountMutation(options: VueApolloComposable.UseMutationOptions<IDeleteAccountMutation, IDeleteAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IDeleteAccountMutation, IDeleteAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IDeleteAccountMutation, IDeleteAccountMutationVariables>(DeleteAccountDocument, options);
}
export type DeleteAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IDeleteAccountMutation, IDeleteAccountMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...Me
  }
}
    ${MeFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a Vue component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMeQuery();
 */
export function useMeQuery(options: VueApolloComposable.UseQueryOptions<IMeQuery, IMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IMeQuery, IMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IMeQuery, IMeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IMeQuery, IMeQueryVariables>(MeDocument, {}, options);
}
export function useMeLazyQuery(options: VueApolloComposable.UseQueryOptions<IMeQuery, IMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IMeQuery, IMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IMeQuery, IMeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IMeQuery, IMeQueryVariables>(MeDocument, {}, options);
}
export type MeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IMeQuery, IMeQueryVariables>;
export const ProfileDocument = gql`
    query Profile {
  myBookmarkedTripsCount
  myBookmarkedArticlesCount
  myFinishedTripsCount
  myTotalKm
}
    `;

/**
 * __useProfileQuery__
 *
 * To run a query within a Vue component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProfileQuery();
 */
export function useProfileQuery(options: VueApolloComposable.UseQueryOptions<IProfileQuery, IProfileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IProfileQuery, IProfileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IProfileQuery, IProfileQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IProfileQuery, IProfileQueryVariables>(ProfileDocument, {}, options);
}
export function useProfileLazyQuery(options: VueApolloComposable.UseQueryOptions<IProfileQuery, IProfileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IProfileQuery, IProfileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IProfileQuery, IProfileQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IProfileQuery, IProfileQueryVariables>(ProfileDocument, {}, options);
}
export type ProfileQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IProfileQuery, IProfileQueryVariables>;